import React from 'react';
import config from './config';
import TTOReportDisplay from './TTOReportDisplay';
import CommercialReportDisplay from './CommercialReportDisplay';

function PriorArtPage({ 
  priorArtForm, 
  setPriorArtForm, 
  handlePriorArtSearch, 
  priorArtLoading,
  priorArtProgress,
  priorArtResults,
  setPriorArtResults,
  setPage,
  user,
  handleLogout 
}) {
  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e0e0e0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <button onClick={() => setPage('search')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d2934', fontSize: '16px' }}>
              ← Back to Search
            </button>
          </div>
          <img src="/logo.svg" alt="PatTrak" style={{ height: '32px', cursor: 'pointer' }} onClick={() => setPage('search')} />
          <h1 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1d2934', marginLeft: '16px' }}>Prior Art Search</h1>
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
          {user ? (
            <button onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d2934' }}>Logout</button>
          ) : (
            <>
              <button onClick={() => setPage('login')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d2934' }}>Log in</button>
              <button onClick={() => setPage('register')} style={{ background: '#53dafc', color: 'white', padding: '8px 16px', borderRadius: '4px', border: 'none', cursor: 'pointer' }}>Sign up</button>
            </>
          )}
        </div>
      </header>

      <main style={{ maxWidth: '1000px', margin: '40px auto', padding: '0 16px' }}>
        <div style={{ background: '#e3f2fd', padding: '20px', borderRadius: '8px', marginBottom: '32px', border: '1px solid #90caf9' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1976d2', marginBottom: '8px' }}>Recent USPTO Prior Art (2021-2024)</h3>
              <p style={{ color: '#1565c0', fontSize: '14px', lineHeight: '1.6', margin: 0 }}>
                AI-powered search of 1.45M patents. <strong>Note:</strong> Preliminary analysis only. Consult a patent attorney for comprehensive searches.
              </p>
            </div>
            {priorArtResults && (
              <div style={{ display: 'flex', gap: '8px', marginLeft: '16px' }}>
                <button
                  onClick={async () => {
                    const token = localStorage.getItem('token');
                    if (!token) {
                      alert('Please login to save searches');
                      return;
                    }
                    try {
                      const response = await fetch(`${config.API_URL}/api/save-prior-art-search?token=${token}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          invention_title: priorArtForm.invention_title,
                          invention_description: priorArtForm.invention_description,
                          priority_date: priorArtForm.priority_date,
                          key_features: priorArtForm.key_features.filter(f => f.trim() !== ''),
                          total_found: priorArtResults.total_found,
                          results: priorArtResults.results,
                          search_strategy: priorArtResults.search_strategy,
                          jurisdiction: priorArtForm.jurisdiction,
                          report_type: priorArtResults.report_type || priorArtForm.report_type,
                          full_report: priorArtResults
                        })
                      });
                      const data = await response.json();
                      if (data.success) {
                        alert('Prior art search saved!');
                      } else {
                        alert('Failed to save search');
                      }
                    } catch (error) {
                      console.error('Error saving search:', error);
                      alert('Failed to save search');
                    }
                  }}
                  style={{
                    background: '#4caf50',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Save Report
                </button>
                <button
                  onClick={async () => {
                    try {
                      const response = await fetch(`${config.API_URL}/api/generate-pdf`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          report_data: priorArtResults,
                          form_data: priorArtForm,
                          report_type: priorArtResults.report_type || priorArtForm.report_type || 'attorney'
                        })
                      });
                      
                      if (response.ok) {
                        const blob = await response.blob();
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `PatTrak_${priorArtForm.invention_title?.substring(0, 20) || 'report'}.pdf`;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                      } else {
                        alert('Failed to generate PDF');
                      }
                    } catch (error) {
                      console.error('PDF generation error:', error);
                      alert('Failed to generate PDF');
                    }
                  }}
                  style={{
                    background: '#1565c0',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Download PDF
                </button>
                <button
                  onClick={() => {
                    setPriorArtResults(null);
                    setPriorArtForm({
                      invention_title: '',
                      invention_description: '',
                      priority_date: '',
                      key_features: ['', '', ''],
                      known_competitors: ''
                    });
                  }}
                  style={{
                    background: '#ff6b35',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap'
                  }}
                >
                  New Search
                </button>
              </div>
            )}
          </div>
        </div>

        
        {/* FORMAL ATTORNEY REPORT HEADER */}
        {priorArtResults && priorArtResults.report_type !== 'tto' && priorArtResults.report_type !== 'commercial' && (
          <div style={{ background: '#1a237e', padding: '24px', borderRadius: '8px', marginBottom: '24px', color: 'white' }}>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: '0 0 8px 0', letterSpacing: '1px' }}>PRELIMINARY PATENTABILITY ASSESSMENT</h2>
            <p style={{ fontSize: '13px', margin: 0, color: '#b3e5fc' }}>AI-Assisted Prior Art Search Report</p>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', fontSize: '13px' }}>
            <div>
              <div style={{ marginBottom: '12px' }}>
                <span style={{ color: '#90caf9', fontWeight: '600' }}>Matter Reference:</span>
                <span style={{ marginLeft: '8px' }}>{priorArtResults.invention_title?.substring(0, 40)}...</span>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <span style={{ color: '#90caf9', fontWeight: '600' }}>Invention Title:</span>
                <span style={{ marginLeft: '8px' }}>{priorArtResults.invention_title}</span>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <span style={{ color: '#90caf9', fontWeight: '600' }}>Priority Date Claimed:</span>
                <span style={{ marginLeft: '8px' }}>{priorArtResults.priority_date}</span>
              </div>
            </div>
            <div>
              <div style={{ marginBottom: '12px' }}>
                <span style={{ color: '#90caf9', fontWeight: '600' }}>Report Date:</span>
                <span style={{ marginLeft: '8px' }}>{new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <span style={{ color: '#90caf9', fontWeight: '600' }}>Prepared By:</span>
                <span style={{ marginLeft: '8px' }}>PatTrak AI Search System</span>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <span style={{ color: '#90caf9', fontWeight: '600' }}>Jurisdictional Focus:</span>
                <span style={{ marginLeft: '8px' }}>
                  {priorArtForm.jurisdiction === 'US' && 'USPTO (US Patent Practice) - §102/103, KSR Framework'}
                  {priorArtForm.jurisdiction === 'UK_EPO' && 'UK/EPO Hybrid (European Practice) - Art. 54/56, Problem-Solution Approach'}
                  {priorArtForm.jurisdiction === 'EPO_STRICT' && 'EPO Strict (Formal European) - Full Problem-Solution Analysis'}
                </span>
              </div>
            </div>
          </div>
          
          <div style={{ marginTop: '16px', padding: '12px', background: 'rgba(255,255,255,0.1)', borderRadius: '6px', fontSize: '11px', lineHeight: '1.6' }}>
            <strong style={{ color: '#ffcc80' }}>IMPORTANT NOTICE:</strong> This document is a preliminary, AI-assisted patentability assessment. It does not constitute legal advice, a formal patentability opinion, or attorney-client privileged communication. The analysis herein is based solely on the limited dataset described and requires independent verification by a qualified patent attorney or agent before any filing, business, or legal decisions are made.
          </div>
        </div>
        )}

        {/* SEARCH LIMITATIONS - Prominent box for UK/EPO modes (Issue 10) */}
        {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && (
        <div style={{ background: '#fff3e0', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '3px solid #e65100' }}>
          <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#bf360c', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px' }}>⚠</span> SEARCH LIMITATIONS
          </h4>
          <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#333', fontWeight: '500' }}>
            This search should be treated as indicative only. The following limitations apply:
          </p>
          <ul style={{ margin: 0, paddingLeft: '24px', color: '#424242', fontSize: '13px', lineHeight: '1.8' }}>
            <li><strong>Pre-2021 patent literature not included</strong> — USPTO data covers 2021-2024 only</li>
            <li><strong>EP, WO, JP, CN, KR not included</strong> — Search limited to US patent documents</li>
            <li><strong>Academic papers included</strong> — Non-patent literature from OpenAlex, Semantic Scholar, and Crossref searched</li>
            <li><strong>Unpublished applications not searchable</strong> — Provisional applications and unpublished PCT filings excluded</li>
          </ul>
          <p style={{ margin: '12px 0 0 0', fontSize: '12px', color: '#666', fontStyle: 'italic' }}>
            A comprehensive prior art search for EP/UK filing should include EPO, WIPO, and relevant national databases.
          </p>
        </div>
        )}
{priorArtResults?.report_type !== 'tto' && priorArtResults?.report_type !== 'commercial' && (
        <div style={{ background: '#fff8e1', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '2px solid #ff9800' }}>
          <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#e65100', marginBottom: '16px' }}>Search Scope, Purpose & Limitations</h4>
          
          {/* Purpose of Search */}
          <div style={{ marginBottom: '16px', padding: '12px', background: '#e3f2fd', borderRadius: '6px', border: '1px solid #90caf9' }}>
            <h5 style={{ fontSize: '13px', fontWeight: 'bold', color: '#1565c0', marginBottom: '8px' }}>Purpose of This Search</h5>
            <p style={{ margin: 0, fontSize: '12px', color: '#333', lineHeight: '1.6' }}>
              {priorArtForm.jurisdiction === 'US' 
                ? 'This is a preliminary patentability search designed to identify potentially relevant prior art for novelty (35 U.S.C. §102) and obviousness (35 U.S.C. §103) assessment.'
                : 'This is a preliminary patentability search designed to identify potentially relevant prior art for novelty (Art. 54 EPC) and inventive step (Art. 56 EPC) assessment.'}
            </p>
          </div>

          {/* What This Search IS NOT */}
          <div style={{ marginBottom: '16px', padding: '12px', background: '#ffebee', borderRadius: '6px', border: '1px solid #ef9a9a' }}>
            <h5 style={{ fontSize: '13px', fontWeight: 'bold', color: '#c62828', marginBottom: '8px' }}>This Search Is NOT:</h5>
            <ul style={{ margin: 0, paddingLeft: '20px', color: '#555', fontSize: '12px', lineHeight: '1.6' }}>
              <li><strong>Freedom-to-Operate (FTO) analysis</strong> — Does not assess infringement risk of third-party patents</li>
              <li><strong>Validity/Invalidity search</strong> — Not intended for challenging existing patents</li>
              <li><strong>Comprehensive state-of-the-art landscape</strong> — Limited to specified databases and timeframes</li>
              <li><strong>Legal advice</strong> — Does not constitute attorney-client privileged communication</li>
            </ul>
          </div>

          {/* Database Limitations */}
          <div style={{ marginBottom: '16px', padding: '12px', background: 'white', borderRadius: '6px', border: '1px solid #ffcc80' }}>
            <h5 style={{ fontSize: '13px', fontWeight: 'bold', color: '#e65100', marginBottom: '8px' }}>Database Coverage & Limitations</h5>
            <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse' }}>
              <tbody>
                <tr>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee', fontWeight: '600', width: '35%' }}>Data Source</td>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee' }}>USPTO granted patents and published applications (2021-2024)</td>
                </tr>
                <tr>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee', fontWeight: '600' }}>Document Count</td>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee' }}>~1.45 million documents</td>
                </tr>
                <tr>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee', fontWeight: '600' }}>Jurisdictions</td>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee' }}>United States only (EP, WIPO, CN, JP, KR not included)</td>
                </tr>
                <tr>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee', fontWeight: '600' }}>Pre-2021 Patents</td>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee' }}>Not included (backfile expansion in progress)</td>
                </tr>
                <tr>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee', fontWeight: '600' }}>Non-Patent Literature</td>
                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #eee' }}>Included via OpenAlex, Semantic Scholar, Crossref (papers before priority date = 102 prior art)</td>
                </tr>
                <tr>
                  <td style={{ padding: '6px 8px', fontWeight: '600' }}>Unpublished Applications</td>
                  <td style={{ padding: '6px 8px' }}>Provisional applications and unpublished PCT filings not searchable</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* AI Methodology Disclaimer - US only (UK/EPO attorneys don't reference AI scoring) */}
          {priorArtForm.jurisdiction === 'US' && (
          <div style={{ marginBottom: '16px', padding: '12px', background: '#f3e5f5', borderRadius: '6px', border: '1px solid #ce93d8' }}>
            <h5 style={{ fontSize: '13px', fontWeight: 'bold', color: '#7b1fa2', marginBottom: '8px' }}>AI Methodology Disclaimer</h5>
            <p style={{ margin: 0, fontSize: '12px', color: '#333', lineHeight: '1.6' }}>
              Similarity scores and relevance rankings are generated using AI-based semantic analysis. These scores are <strong>non-determinative</strong> and serve only as preliminary ranking indicators. They have no legal significance and should not be relied upon for legal conclusions. All AI-generated analysis requires attorney verification.
            </p>
          </div>
          )}

          {/* Formal Legal Disclaimer */}
          <div style={{ padding: '14px', background: '#c62828', borderRadius: '6px' }}>
            <p style={{ margin: 0, fontSize: '12px', color: 'white', fontWeight: '500', lineHeight: '1.6' }}>
              <strong>LEGAL DISCLAIMER:</strong> This report is a preliminary, informational, AI-assisted search output. It does not constitute legal advice, a formal patentability opinion, or attorney-client privileged communication. No guarantee of completeness or accuracy is provided. A qualified patent attorney or agent must conduct independent professional analysis before relying on these results for any legal, business, or filing decision. This search is not a substitute for a comprehensive prior art search conducted by a registered patent practitioner.
            </p>
          </div>
        </div>
	)}
        {!priorArtResults && (
        <form onSubmit={handlePriorArtSearch} style={{ background: '#f9f9f9', padding: '32px', borderRadius: '8px', marginBottom: '32px' }}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>Invention Title *</label>
            <input
              type="text"
              value={priorArtForm.invention_title}
              onChange={(e) => setPriorArtForm({...priorArtForm, invention_title: e.target.value})}
              required
              placeholder="e.g., Battery Cooling System"
              style={{ width: '100%', padding: '12px', border: '2px solid #ddd', borderRadius: '4px', fontSize: '16px' }}
            />
          </div>


          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>Invention Description *</label>
            <textarea
              value={priorArtForm.invention_description}
              onChange={(e) => setPriorArtForm({...priorArtForm, invention_description: e.target.value})}
              required
              placeholder="Describe your invention in detail..."
              rows="6"
              style={{ width: '100%', padding: '12px', border: '2px solid #ddd', borderRadius: '4px', fontSize: '16px', resize: 'vertical' }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>
              Distilled Independent Claim <span style={{ fontWeight: '400', fontSize: '14px', color: '#666' }}>(Recommended)</span>
            </label>
            <div style={{ background: '#fce4ec', padding: '12px', borderRadius: '4px', marginBottom: '12px', border: '1px solid #f48fb1' }}>
              <p style={{ fontSize: '13px', color: '#c2185b', margin: 0, lineHeight: '1.5' }}>
                <strong>What is this?</strong> Write your invention as a single claim statement. This is the anchor for professional claim charts. Structure it as: <em>"A [system/method/device] comprising: (a) [first element]; (b) [second element]; (c) [third element]..."</em>
              </p>
            </div>
            <textarea
              value={priorArtForm.distilled_claim || ''}
              onChange={(e) => setPriorArtForm({...priorArtForm, distilled_claim: e.target.value})}
              placeholder="Example: An automated irrigation system for agricultural fields comprising: (a) a plurality of wireless soil moisture sensor nodes distributed across a field, each node including probes at multiple soil depths; (b) a controller configured to receive soil measurements and execute a machine learning model that predicts irrigation timing for each zone; and (c) valve control outputs configured to independently actuate irrigation valves to deliver different water amounts based on the predicted schedule."
              rows="5"
              style={{ width: '100%', padding: '12px', border: '2px solid #ddd', borderRadius: '4px', fontSize: '14px', resize: 'vertical' }}
            />
            <p style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>This helps attorneys see exactly what elements need to be compared against prior art.</p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>
              Priority Date * <span style={{ fontWeight: '400', fontSize: '14px', color: '#666' }}>(Filing or earliest claim date)</span>
            </label>
            <input
              type="date"
              value={priorArtForm.priority_date}
              onChange={(e) => setPriorArtForm({...priorArtForm, priority_date: e.target.value})}
              required
              max={new Date().toISOString().split('T')[0]}
              style={{ padding: '12px', border: '2px solid #ddd', borderRadius: '4px', fontSize: '16px' }}
            />
            <p style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>Only patents granted before this date will be considered.</p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>Key Features of Your Invention <span style={{ color: '#c62828' }}>*</span></label>
            <div style={{ background: '#e3f2fd', padding: '12px', borderRadius: '4px', marginBottom: '12px', border: '1px solid #90caf9' }}>
              <p style={{ fontSize: '13px', color: '#1565c0', margin: 0, lineHeight: '1.5' }}>
                <strong>Why this matters:</strong> Key features enable the AI to create a proper <strong>Claim Chart</strong> - a feature-by-feature comparison against prior art patents. This is what patent attorneys use to assess novelty and draft strong claims. List 2-3 specific technical features that make your invention unique.
              </p>
            </div>
            {priorArtForm.key_features.map((feature, index) => (
              <input
                key={index}
                type="text"
                value={feature}
                onChange={(e) => {
                  const newFeatures = [...priorArtForm.key_features];
                  newFeatures[index] = e.target.value;
                  setPriorArtForm({...priorArtForm, key_features: newFeatures});
                }}
                placeholder={index === 0 ? "Feature 1 (required): e.g., wireless sensors at multiple depths" : `Feature ${index + 1}: e.g., machine learning prediction`}
                style={{ width: '100%', padding: '10px', border: index === 0 ? '2px solid #1565c0' : '2px solid #ddd', borderRadius: '4px', fontSize: '14px', marginBottom: '8px' }}
              />
            ))}
            <p style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>Enter at least one key feature. Be specific about what makes your invention technically distinct.</p>
          </div>

          {/* Report Type Selector - Phase 6 */}
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>
              Report Type <span style={{ fontWeight: '400', fontSize: '14px', color: '#666' }}>(Choose your audience)</span>
            </label>
            <select
              value={priorArtForm.report_type}
              onChange={(e) => setPriorArtForm({...priorArtForm, report_type: e.target.value})}
              style={{ padding: '12px', border: '2px solid #ddd', borderRadius: '4px', fontSize: '16px', minWidth: '300px' }}
            >
              <option value="attorney">Attorney Report - Formal legal analysis for patent counsel</option>
              <option value="tto">TTO Report - Commercial assessment for Technology Transfer</option>
              <option value="commercial">Commercial Report - Business-focused for investors/partners</option>
            </select>
            <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
              {priorArtForm.report_type === 'attorney' && 'Generates formal legal analysis with §102/103 or Art. 54/56 framework, claim construction, and preliminary opinion. Select jurisdiction below.'}
              {priorArtForm.report_type === 'tto' && 'Generates TTO decision-support report with go/no-go recommendation, commercial potential, FTO snapshot, and industry fit analysis.'}
              {priorArtForm.report_type === 'commercial' && 'Generates investor-ready report with value proposition, competitive positioning, IP strength, and partnership opportunities.'}
            </p>
          </div>

          {/* Jurisdiction Selector - Only shown for Attorney Reports */}
          {priorArtForm.report_type === 'attorney' && (
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>
              Report Jurisdiction <span style={{ fontWeight: '400', fontSize: '14px', color: '#666' }}>(Legal framework for analysis)</span>
            </label>
            <select
              value={priorArtForm.jurisdiction}
              onChange={(e) => setPriorArtForm({...priorArtForm, jurisdiction: e.target.value})}
              style={{ padding: '12px', border: '2px solid #ddd', borderRadius: '4px', fontSize: '16px', minWidth: '300px' }}
            >
              <option value="US">US (USPTO) - §102/103, KSR, MPEP framework</option>
              <option value="UK_EPO">UK/EPO Hybrid - Art. 54/56, Problem-Solution Approach</option>
              <option value="EPO_STRICT">EPO Strict - Full Problem-Solution, stricter standards</option>
            </select>
          </div>
          )}

          {priorArtLoading ? (
            /* Professional Progress Bar */
            <div style={{ 
              width: '100%', 
              background: '#f0f4f8', 
              borderRadius: '8px', 
              padding: '24px',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', fontWeight: '600', color: '#1d2934' }}>
                  {priorArtProgress?.stage || 'Starting analysis...'}
                </span>
                <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#1976d2' }}>
                  {priorArtProgress?.progress || 0}%
                </span>
              </div>
              <div style={{ 
                width: '100%', 
                height: '12px', 
                background: '#e0e0e0', 
                borderRadius: '6px',
                overflow: 'hidden'
              }}>
                <div style={{ 
                  width: `${priorArtProgress?.progress || 0}%`, 
                  height: '100%', 
                  background: 'linear-gradient(90deg, #53dafc 0%, #1976d2 100%)',
                  borderRadius: '6px',
                  transition: 'width 0.3s ease-in-out'
                }} />
              </div>
              <p style={{ fontSize: '13px', color: '#5e778a', marginTop: '12px', textAlign: 'center' }}>
                AI is analyzing patents against your invention. This typically takes 2-4 minutes.
              </p>
            </div>
          ) : (
            <button
              type="submit"
              style={{
                width: '100%',
                background: '#53dafc',
                color: 'white',
                padding: '16px',
                borderRadius: '4px',
                border: 'none',
                fontSize: '18px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Search Prior Art
            </button>
          )}
        </form>
        )}

        {priorArtResults && (
          <div>
	    <TTOReportDisplay priorArtResults={priorArtResults} />
	    <CommercialReportDisplay priorArtResults={priorArtResults} />
            
            {priorArtResults.report_type !== 'tto' && priorArtResults.report_type !== 'commercial' && (
            <>
            {/* PART 1: SEARCH REPORT - UK/EPO Structure (Issue 2) */}
            {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && (
            <div style={{ background: '#1565c0', padding: '12px 20px', borderRadius: '4px', marginBottom: '16px' }}>
              <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: 'white', margin: 0, letterSpacing: '2px' }}>
                PART 1: SEARCH REPORT
              </h2>
            </div>
            )}

            <div style={{ background: '#f0f0f0', padding: '20px', borderRadius: '8px', marginBottom: '24px' }}>
              <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>Results</h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '16px' }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '4px' }}>
                  <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#1976d2' }}>{priorArtResults.total_found?.toLocaleString()}</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>Total Prior Art</div>
                </div>
                <div style={{ background: 'white', padding: '16px', borderRadius: '4px' }}>
                  <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#7b1fa2' }}>{priorArtResults.granted_count?.toLocaleString() || 0}</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>Granted Patents</div>
                </div>
                <div style={{ background: 'white', padding: '16px', borderRadius: '4px' }}>
                  <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#00796b' }}>{priorArtResults.applications_count?.toLocaleString() || 0}</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>Pending Applications</div>
                </div>
                <div style={{ background: 'white', padding: '16px', borderRadius: '4px' }}>
                  <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#388e3c' }}>{priorArtResults.results_shown}</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>AI Scored</div>
                </div>
              </div>

              {/* Citation Insights Section */}
              {priorArtResults.citation_insights && (
                <div style={{ background: '#f3e5f5', padding: '20px', borderRadius: '8px', marginTop: '20px', border: '1px solid #ce93d8' }}>
                  <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: '#7b1fa2', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>📊</span> Citation Landscape Analysis
                  </h4>
                  
                  <p style={{ color: '#333', marginBottom: '16px', lineHeight: '1.6' }}>
                    {priorArtResults.citation_insights.summary}
                  </p>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '16px' }}>
                    <div style={{ background: 'white', padding: '12px', borderRadius: '4px', textAlign: 'center' }}>
                      <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#7b1fa2' }}>{priorArtResults.citation_insights.total_forward_citations}</div>
                      <div style={{ fontSize: '11px', color: '#666' }}>Total Forward Citations</div>
                    </div>
                    <div style={{ background: 'white', padding: '12px', borderRadius: '4px', textAlign: 'center' }}>
                      <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#5c6bc0' }}>{priorArtResults.citation_insights.average_forward_citations}</div>
                      <div style={{ fontSize: '11px', color: '#666' }}>Avg Citations/Patent</div>
                    </div>
                    <div style={{ background: 'white', padding: '12px', borderRadius: '4px', textAlign: 'center' }}>
                      <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#388e3c' }}>{priorArtResults.citation_insights.citation_density}</div>
                      <div style={{ fontSize: '11px', color: '#666' }}>Citation Density</div>
                    </div>
                    <div style={{ background: 'white', padding: '12px', borderRadius: '4px', textAlign: 'center' }}>
                      <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#f57c00' }}>{priorArtResults.citation_insights.technology_maturity}</div>
                      <div style={{ fontSize: '11px', color: '#666' }}>Tech Maturity</div>
                    </div>
                  </div>
                  
                  {priorArtResults.citation_insights.most_cited_patents && priorArtResults.citation_insights.most_cited_patents.length > 0 && (
                    <div style={{ marginBottom: '16px' }}>
                      <h5 style={{ fontSize: '13px', fontWeight: '600', color: '#7b1fa2', marginBottom: '8px' }}>Most Influential Prior Art</h5>
                      <div style={{ background: 'white', padding: '12px', borderRadius: '4px' }}>
                        {priorArtResults.citation_insights.most_cited_patents.slice(0, 3).map((patent, idx) => (
                          <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: idx < 2 ? '1px solid #eee' : 'none' }}>
                            <div>
                              <a href={`https://patents.google.com/patent/US${patent.patent_number}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', fontWeight: '600', textDecoration: 'none' }}>
                                US{patent.patent_number}
                              </a>
                              <span style={{ color: '#666', fontSize: '12px', marginLeft: '8px' }}>{patent.title}</span>
                            </div>
                            <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600' }}>
                              {patent.forward_citations} citations
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {priorArtResults.citation_insights.insights && priorArtResults.citation_insights.insights.length > 0 && (
                    <div>
                      <h5 style={{ fontSize: '13px', fontWeight: '600', color: '#7b1fa2', marginBottom: '8px' }}>Key Insights</h5>
                      <ul style={{ margin: 0, paddingLeft: '20px' }}>
                        {priorArtResults.citation_insights.insights.map((insight, idx) => (
                          <li key={idx} style={{ color: '#555', fontSize: '13px', marginBottom: '4px' }}>{insight}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ATTORNEY SUMMARY SHEET - One-Page Overview */}
            {priorArtResults.results?.length > 0 && (
              <div style={{ background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)', padding: '24px', borderRadius: '8px', marginBottom: '24px', color: 'white', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '12px' }}>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>Attorney Summary Sheet</h2>
                  <span style={{
                    padding: '6px 16px',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    background: priorArtResults.risk_pathways?.risk_level === 'high' ? '#d32f2f' :
                               priorArtResults.risk_pathways?.risk_level === 'moderate' ? '#f57c00' : '#388e3c',
                    color: 'white'
                  }}>
                    {priorArtResults.risk_pathways?.risk_level?.toUpperCase() || 'UNKNOWN'} {priorArtForm.jurisdiction === 'US' ? '103' : 'Art. 56'} RISK
                  </span>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                  {/* Left Column - Most Dangerous References */}
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px', color: '#ffcdd2' }}>Most Coverage References</h3>
                    {priorArtResults.results.slice(0, 3).map((patent, idx) => {
                      const scoreColor = patent.similarity_score >= 80 ? '#ff8a80' : patent.similarity_score >= 60 ? '#ffcc80' : '#fff59d';
                      const matrix = patent.claim_feature_matrix || {};
                      const totalFeatures = priorArtForm.key_features?.filter(f => f.trim()).length || 0;
                      // Only count user's features (keys 1, 2, 3, etc.), not AI-added elements
                      const userFeatureKeys = Array.from({length: totalFeatures}, (_, i) => (i + 1).toString());
                      const yesCount = userFeatureKeys.filter(k => matrix[k]?.disclosed === 'yes').length;
                      const partialCount = userFeatureKeys.filter(k => matrix[k]?.disclosed === 'partial').length;
                      return (
                        <div key={patent.patent_number} style={{ background: 'rgba(255,255,255,0.1)', padding: '10px', borderRadius: '6px', marginBottom: '8px', borderLeft: '4px solid ' + scoreColor }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <a href={'https://patents.google.com/patent/US' + patent.patent_number} target="_blank" rel="noopener noreferrer" style={{ color: '#90caf9', fontWeight: 'bold', textDecoration: 'none' }}>
                              US{patent.patent_number}
                            </a>
                            {priorArtForm.jurisdiction === 'US' && <span style={{ color: scoreColor, fontWeight: 'bold' }}>{patent.similarity_score}%</span>}
                          </div>
                          <p style={{ fontSize: '12px', margin: '4px 0 0 0', color: '#e0e0e0', lineHeight: '1.4' }}>
                            {patent.title?.substring(0, 60)}{patent.title?.length > 60 ? '...' : ''}
                          </p>
                          {totalFeatures > 0 && (
                            <p style={{ fontSize: '11px', margin: '4px 0 0 0', color: '#b0bec5' }}>
                              Discloses {yesCount}/{totalFeatures} features{partialCount > 0 ? ` (+${partialCount} partial)` : ''}
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* Right Column - Gap Analysis & Next Steps */}
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px', color: '#c8e6c9' }}>Gap Analysis</h3>
                    {(() => {
                      const features = priorArtForm.key_features?.filter(f => f.trim()) || [];
                      const topPatents = priorArtResults.results.slice(0, 6);
                      const gaps = [];
                      features.forEach((feature, idx) => {
                        const featureNum = (idx + 1).toString();
                        const allNo = topPatents.every(p => {
                          const matrix = p.claim_feature_matrix || {};
                          return !matrix[featureNum] || matrix[featureNum].disclosed === 'no';
                        });
                        if (allNo) gaps.push(feature);
                      });
                      
                      if (gaps.length > 0) {
                        return (
                          <div style={{ background: 'rgba(76,175,80,0.2)', padding: '10px', borderRadius: '6px', marginBottom: '12px' }}>
                            <p style={{ fontSize: '12px', fontWeight: '600', color: '#a5d6a7', margin: '0 0 6px 0' }}>Potential Differentiators (not found in top art):</p>
                            <ul style={{ margin: 0, paddingLeft: '16px', fontSize: '12px', color: '#e0e0e0' }}>
                              {gaps.map((gap, i) => <li key={i} style={{ marginBottom: '4px' }}>{gap}</li>)}
                            </ul>
                          </div>
                        );
                      } else if (features.length > 0) {
                        return (
                          <div style={{ background: 'rgba(244,67,54,0.2)', padding: '10px', borderRadius: '6px', marginBottom: '12px' }}>
                            <p style={{ fontSize: '12px', color: '#ef9a9a', margin: 0 }}>All key features found in at least one reference. Novelty may require claim narrowing.</p>
                          </div>
                        );
                      }
                      return null;
                    })()}

                    <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px', color: '#bbdefb' }}>Recommended Next Steps</h3>
                    <div style={{ background: 'rgba(255,255,255,0.1)', padding: '10px', borderRadius: '6px', fontSize: '12px', color: '#e0e0e0', lineHeight: '1.6' }}>
                      {priorArtResults.risk_pathways?.risk_level === 'high' ? (
                        <ul style={{ margin: 0, paddingLeft: '16px' }}>
                          <li>Share this report with patent counsel for comprehensive review</li>
                          <li>Discuss claim scope and potential amendments with counsel</li>
                          <li>Request counsel evaluation of {priorArtForm.jurisdiction === 'US' ? '103 combination pathways' : 'Art. 56 obviousness combinations'}</li>
                          <li>Do not proceed with filing without attorney guidance</li>
                        </ul>
                      ) : priorArtResults.risk_pathways?.risk_level === 'moderate' ? (
                        <ul style={{ margin: 0, paddingLeft: '16px' }}>
                          <li>Share this report with patent counsel for detailed {priorArtForm.jurisdiction === 'US' ? '102/103' : 'Art. 54/56'} analysis</li>
                          <li>Discuss potential claim amendments or specification enhancements with counsel</li>
                          <li>Document distinctions from cited references</li>
                        </ul>
                      ) : (
                        <ul style={{ margin: 0, paddingLeft: '16px' }}>
                          <li>Share this report with patent counsel for filing strategy review</li>
                          <li>Monitor for new publications in relevant CPC classes</li>
                          <li>Document this search in prosecution file wrapper if counsel deems appropriate</li>
                        </ul>
                      )}
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,0.2)', fontSize: '11px', color: '#9e9e9e' }}>
                  This summary is AI-generated based on the searched dataset. It is not legal advice. Full attorney review of cited references is recommended.
                </div>
              </div>
            )}

            {/* CLOSEST PRIOR ART - UK/EPO mode */}
            {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && priorArtResults.results?.length > 0 && (
              <div style={{ background: '#fff3e0', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '2px solid #ef6c00' }}>
                <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#e65100', marginBottom: '4px' }}>
                  Closest Prior Art
                </h3>
                <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
                  In accordance with EPO practice, the following document has been identified as the closest prior art for the Problem-Solution Approach analysis.
                </p>

                {(() => {
                  const closestArt = priorArtResults.results[0];
                  const matrix = closestArt?.claim_feature_matrix || {};
                  const yesCount = Object.values(matrix).filter(m => m.disclosed === 'yes').length;
                  const partialCount = Object.values(matrix).filter(m => m.disclosed === 'partial').length;
                  const totalFeatures = priorArtForm.key_features?.filter(f => f.trim()).length || 0;
                  
                  return (
                    <div style={{ background: 'white', padding: '16px', borderRadius: '6px', border: '1px solid #ffcc80' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                        <div>
                          <a href={'https://patents.google.com/patent/US' + closestArt.patent_number} target="_blank" rel="noopener noreferrer" style={{ fontSize: '18px', fontWeight: 'bold', color: '#1565c0', textDecoration: 'none' }}>
                            US{closestArt.patent_number}
                          </a>
                          <span style={{ marginLeft: '12px', padding: '4px 12px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold', background: '#ef6c00', color: 'white' }}>
                            CLOSEST PRIOR ART
                          </span>
                        </div>
                        {totalFeatures > 0 && (
                          <span style={{ fontSize: '12px', color: '#666', background: '#f5f5f5', padding: '4px 10px', borderRadius: '4px' }}>
                            Features: {yesCount} disclosed, {partialCount} partial, {totalFeatures - yesCount - partialCount} not found
                          </span>
                        )}
                      </div>

                      <p style={{ fontSize: '15px', fontWeight: '500', color: '#333', margin: '0 0 8px 0' }}>
                        {closestArt.title}
                      </p>

                      <p style={{ fontSize: '13px', color: '#666', margin: '0 0 12px 0' }}>
                        {closestArt.assignee} | Filed: {closestArt.filing_date || closestArt.grant_date || 'N/A'}
                      </p>

                      <div style={{ background: '#e3f2fd', padding: '12px', borderRadius: '4px', marginBottom: '12px', border: '1px solid #90caf9' }}>
                        <p style={{ fontSize: '12px', fontWeight: '600', color: '#1565c0', margin: '0 0 6px 0' }}>
                          Selection Justification (EPO Guidelines G-VII, 5.1):
                        </p>
                        <p style={{ fontSize: '13px', color: '#333', margin: 0, lineHeight: '1.6' }}>
                          This document is selected as the closest prior art because it: (i) is from the same or adjacent technical field; (ii) addresses a similar technical problem; and (iii) has the most features in common with the claimed invention, requiring the fewest modifications to arrive at the invention.
                        </p>
                      </div>

                      <div style={{ background: '#f5f5f5', padding: '12px', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                        <p style={{ fontSize: '12px', fontWeight: '600', color: '#333', margin: '0 0 6px 0' }}>
                          Technical Relevance:
                        </p>
                        <p style={{ fontSize: '13px', color: '#555', margin: 0, lineHeight: '1.6' }}>
                          {closestArt.relevance_explanation || 'This reference represents the most relevant starting point for assessing inventive step under Art. 56 EPC. The distinguishing features and objective technical problem are analysed in the Problem-Solution Approach section below.'}
                        </p>
                      </div>
                    </div>
                  );
                })()}

                {priorArtResults.results.length > 1 && (
                  <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #ffcc80' }}>
                    <p style={{ fontSize: '12px', fontWeight: '600', color: '#e65100', marginBottom: '8px' }}>
                      Secondary References (for combination attacks under Art. 56):
                    </p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {priorArtResults.results.slice(1, 5).map((patent) => (
                        <a 
                          key={patent.patent_number}
                          href={'https://patents.google.com/patent/US' + patent.patent_number} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          style={{ 
                            fontSize: '12px', 
                            color: '#1565c0', 
                            textDecoration: 'none',
                            background: 'white',
                            padding: '4px 10px',
                            borderRadius: '4px',
                            border: '1px solid #e0e0e0'
                          }}
                        >
                          US{patent.patent_number}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* MOST DANGEROUS REFERENCES - Detailed Threat Analysis (US only) */}
            {priorArtForm.jurisdiction === 'US' && priorArtResults.results?.filter(p => p.similarity_score >= 60).length > 0 && (
              <div style={{ background: '#ffebee', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '2px solid #c62828' }}>
                <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#c62828', marginBottom: '4px' }}>
                  Most Dangerous References
                </h3>
                <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
                  {priorArtForm.jurisdiction === 'US' 
                    ? 'These patents scored 60%+ similarity and pose the greatest risk to patentability. Each includes a specific threat rationale.'
                    : 'These references pose the greatest risk to patentability based on feature overlap. Each includes a specific threat rationale.'}
                </p>
                
                {priorArtResults.results.filter(p => p.similarity_score >= 60).slice(0, 6).map((patent, idx) => {
                  const scoreColor = patent.similarity_score >= 80 ? '#c62828' : '#ef6c00';
                  const riskLabel = patent.similarity_score >= 80 ? 'CRITICAL' : 'HIGH';
                  const matrix = patent.claim_feature_matrix || {};
                  const yesCount = Object.values(matrix).filter(m => m.disclosed === 'yes').length;
                  const partialCount = Object.values(matrix).filter(m => m.disclosed === 'partial').length;
                  const totalFeatures = priorArtForm.key_features?.filter(f => f.trim()).length || 0;
                  
                  return (
                    <div key={patent.patent_number} style={{ background: 'white', padding: '16px', borderRadius: '6px', marginBottom: '12px', borderLeft: `4px solid ${scoreColor}` }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <div>
                          <a href={'https://patents.google.com/patent/US' + patent.patent_number} target="_blank" rel="noopener noreferrer" style={{ fontSize: '16px', fontWeight: 'bold', color: '#1565c0', textDecoration: 'none' }}>
                            US{patent.patent_number}
                          </a>
                          <span style={{ marginLeft: '12px', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', background: scoreColor, color: 'white' }}>
                            {priorArtForm.jurisdiction === 'US' ? `${riskLabel} - ${patent.similarity_score}%` : riskLabel}
                          </span>
                        </div>
                        {totalFeatures > 0 && (
                          <span style={{ fontSize: '11px', color: '#666', background: '#f5f5f5', padding: '2px 8px', borderRadius: '4px' }}>
                            {yesCount}Y / {partialCount}P / {totalFeatures - yesCount - partialCount}N
                          </span>
                        )}
                      </div>
                      
                      <p style={{ fontSize: '14px', fontWeight: '500', color: '#333', margin: '0 0 8px 0' }}>
                        {patent.title}
                      </p>
                      
                      <p style={{ fontSize: '12px', color: '#666', margin: '0 0 8px 0' }}>
                        {patent.assignee} | Filed: {patent.filing_date || patent.grant_date || 'N/A'}
                      </p>
                      
                      <div style={{ background: '#fff3e0', padding: '10px', borderRadius: '4px', border: '1px solid #ffcc80' }}>
                        <p style={{ fontSize: '12px', fontWeight: '600', color: '#e65100', margin: '0 0 4px 0' }}>
                          Threat Rationale:
                        </p>
                        <p style={{ fontSize: '13px', color: '#333', margin: 0, lineHeight: '1.5' }}>
                          {patent.relevance_explanation || 'This reference shows significant overlap with the claimed invention. Review the full patent for specific disclosures.'}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}


            {priorArtResults.executive_summary && (
              <div style={{ background: '#e8f5e9', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '1px solid #a5d6a7' }}>
                <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#2e7d32', marginBottom: '12px' }}>Executive Summary</h3>
                <p style={{ color: '#333', fontSize: '14px', lineHeight: '1.7', whiteSpace: 'pre-wrap' }}>{priorArtResults.executive_summary}</p>
              </div>
            )}


            {/* PART 2: LEGAL ANALYSIS - UK/EPO Structure (Issue 2) */}
            {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && (
            <div style={{ background: '#6a1b9a', padding: '12px 20px', borderRadius: '4px', marginBottom: '16px' }}>
              <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: 'white', margin: 0, letterSpacing: '2px' }}>
                PART 2: LEGAL ANALYSIS
              </h2>
            </div>
            )}

            {/* FEATURE MAPPING TABLE - UK/EPO only */}
            {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && priorArtResults.feature_mapping?.feature_mapping?.length > 0 && (
              <div style={{ background: '#fff8e1', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '2px solid #ff9800' }}>
                <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#e65100', margin: '0 0 16px 0' }}>
                  Feature Mapping Table
                </h3>
                <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px', fontStyle: 'italic' }}>
                  Feature-by-feature comparison against closest prior art documents (D1, D2, D3)
                </p>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                    <thead>
                      <tr style={{ background: '#ffe082' }}>
                        <th style={{ padding: '10px', border: '1px solid #ffb74d', textAlign: 'left', fontWeight: 'bold' }}>Feature</th>
                        <th style={{ padding: '10px', border: '1px solid #ffb74d', textAlign: 'center', fontWeight: 'bold' }}>D1</th>
                        <th style={{ padding: '10px', border: '1px solid #ffb74d', textAlign: 'center', fontWeight: 'bold' }}>D2</th>
                        <th style={{ padding: '10px', border: '1px solid #ffb74d', textAlign: 'center', fontWeight: 'bold' }}>D3</th>
                        <th style={{ padding: '10px', border: '1px solid #ffb74d', textAlign: 'center', fontWeight: 'bold' }}>Novelty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {priorArtResults.feature_mapping.feature_mapping.map((row, idx) => (
                        <tr key={idx} style={{ background: idx % 2 === 0 ? 'white' : '#fff8e1' }}>
                          <td style={{ padding: '10px', border: '1px solid #ffcc80' }}>{row.feature_description}</td>
                          <td style={{ padding: '10px', border: '1px solid #ffcc80', textAlign: 'center' }}>
                            <span style={{ 
                              padding: '2px 8px', 
                              borderRadius: '12px', 
                              fontSize: '11px',
                              background: row.d1_status === 'Disclosed' ? '#ffcdd2' : row.d1_status === 'Not disclosed' ? '#c8e6c9' : '#fff9c4',
                              color: row.d1_status === 'Disclosed' ? '#c62828' : row.d1_status === 'Not disclosed' ? '#2e7d32' : '#f57f17'
                            }}>
                              {row.d1_status}
                            </span>
                          </td>
                          <td style={{ padding: '10px', border: '1px solid #ffcc80', textAlign: 'center' }}>
                            <span style={{ 
                              padding: '2px 8px', 
                              borderRadius: '12px', 
                              fontSize: '11px',
                              background: row.d2_status === 'Disclosed' ? '#ffcdd2' : row.d2_status === 'Not disclosed' ? '#c8e6c9' : '#fff9c4',
                              color: row.d2_status === 'Disclosed' ? '#c62828' : row.d2_status === 'Not disclosed' ? '#2e7d32' : '#f57f17'
                            }}>
                              {row.d2_status}
                            </span>
                          </td>
                          <td style={{ padding: '10px', border: '1px solid #ffcc80', textAlign: 'center' }}>
                            <span style={{ 
                              padding: '2px 8px', 
                              borderRadius: '12px', 
                              fontSize: '11px',
                              background: row.d3_status === 'Disclosed' ? '#ffcdd2' : row.d3_status === 'Not disclosed' ? '#c8e6c9' : '#fff9c4',
                              color: row.d3_status === 'Disclosed' ? '#c62828' : row.d3_status === 'Not disclosed' ? '#2e7d32' : '#f57f17'
                            }}>
                              {row.d3_status}
                            </span>
                          </td>
                          <td style={{ padding: '10px', border: '1px solid #ffcc80', textAlign: 'center' }}>
                            <span style={{ 
                              padding: '2px 8px', 
                              borderRadius: '12px', 
                              fontSize: '11px',
                              fontWeight: 'bold',
                              background: row.novelty_impact === 'Novel' ? '#c8e6c9' : row.novelty_impact === 'Anticipated' ? '#ffcdd2' : '#fff9c4',
                              color: row.novelty_impact === 'Novel' ? '#2e7d32' : row.novelty_impact === 'Anticipated' ? '#c62828' : '#f57f17'
                            }}>
                              {row.novelty_impact}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {priorArtResults.feature_mapping.novelty_summary && (
                  <div style={{ marginTop: '16px', padding: '12px', background: '#e8f5e9', borderRadius: '6px' }}>
                    <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#2e7d32', marginBottom: '8px' }}>
                      Art. 54 Assessment: {priorArtResults.feature_mapping.novelty_summary.art_54_assessment}
                    </div>
                    {priorArtResults.feature_mapping.novelty_summary.key_novel_features?.length > 0 && (
                      <div style={{ fontSize: '12px', color: '#333' }}>
                        <strong>Key Novel Features:</strong> {priorArtResults.feature_mapping.novelty_summary.key_novel_features.join(', ')}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* NOVELTY ANALYSIS - Jurisdiction-Aware Section */}
            {priorArtResults.novelty_analysis && (
              <div style={{ background: '#e3f2fd', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '2px solid #1565c0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                  <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#0d47a1', margin: 0 }}>
                    {priorArtForm.jurisdiction === 'US' && '35 U.S.C. §102 Novelty Analysis'}
                    {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && 'Art. 54 EPC Novelty Analysis'}
                  </h3>
                  <span style={{
                    padding: '6px 16px',
                    borderRadius: '20px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    background: priorArtResults.novelty_analysis.conclusion === 'novel' ? '#2e7d32' :
                               priorArtResults.novelty_analysis.conclusion === 'anticipated' ? '#c62828' : '#f57c00',
                    color: 'white'
                  }}>
                    {priorArtResults.novelty_analysis.conclusion === 'novel' ? 'NOVEL' :
                     priorArtResults.novelty_analysis.conclusion === 'anticipated' ? 'ANTICIPATED' : 'UNCERTAIN'}
                  </span>
                </div>
                
                <div style={{ background: '#e8eaf6', padding: '12px', borderRadius: '6px', marginBottom: '12px', border: '1px solid #9fa8da' }}>
                  <h5 style={{ fontSize: '11px', fontWeight: 'bold', color: '#3949ab', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Legal Framework</h5>
                  {priorArtForm.jurisdiction === 'US' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>35 U.S.C. §102</strong> - A patent may not be obtained if the claimed invention was patented, described in a printed publication, or in public use before the effective filing date.
                      <em style={{ color: '#5c6bc0' }}> See MPEP §2131 (Anticipation); §2131.01 (Multiple Reference 102 Rejections). </em>
                      Under <em>Verdegaal Bros., Inc. v. Union Oil Co.</em>, 814 F.2d 628 (Fed. Cir. 1987), anticipation requires that each and every element of the claimed invention be disclosed in a single prior art reference.
                    </p>
                  )}
                  {priorArtForm.jurisdiction === 'UK_EPO' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>Article 54 EPC</strong> - An invention shall be considered to be new if it does not form part of the state of the art. The state of the art comprises everything made available to the public before the filing date.
                      <em style={{ color: '#5c6bc0' }}> See EPO Guidelines G-VI, 2 (Novelty); G-VI, 3 (State of the Art). </em>
                      Per <em>T 198/84 (Thiokol)</em>, anticipation requires that a single prior art document disclose all features of the claim, either explicitly or implicitly.
                    </p>
                  )}
                  {priorArtForm.jurisdiction === 'EPO_STRICT' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>Article 54 EPC (Strict)</strong> - An invention shall be considered to be new if it does not form part of the state of the art.
                      <em style={{ color: '#5c6bc0' }}> See EPO Guidelines G-VI, 2; Case Law of the Boards of Appeal, I.C.3. </em>
                      Per <em>T 124/87</em>, implicit disclosure must be "directly and unambiguously derivable" from the prior art document. <em>T 198/84 (Thiokol)</em> confirms that a novelty-destroying disclosure must be enabling.
                    </p>
                  )}
                </div>

                <div style={{ background: 'white', padding: '16px', borderRadius: '6px', marginBottom: '16px', border: '1px solid #90caf9' }}>
                  <p style={{ fontSize: '14px', color: '#333', lineHeight: '1.6', margin: 0 }}>
                    {priorArtResults.novelty_analysis.summary}
                  </p>
                </div>

                {priorArtResults.novelty_analysis.closest_reference && (
                  <div style={{ background: '#fff8e1', padding: '12px', borderRadius: '6px', marginBottom: '16px', border: '1px solid #ffcc80' }}>
                    <h4 style={{ fontSize: '13px', fontWeight: 'bold', color: '#e65100', marginBottom: '8px' }}>Closest Reference:</h4>
                    <div style={{ fontSize: '13px', color: '#333' }}>
                      <a href={'https://patents.google.com/patent/US' + priorArtResults.novelty_analysis.closest_reference.patent_number?.replace('US', '')} 
                         target="_blank" rel="noopener noreferrer" style={{ color: '#1565c0', fontWeight: '600' }}>
                        {priorArtResults.novelty_analysis.closest_reference.patent_number}
                      </a>
                      {priorArtResults.novelty_analysis.closest_reference.title && (
                        <span> - {priorArtResults.novelty_analysis.closest_reference.title}</span>
                      )}
                      <div style={{ marginTop: '8px' }}>
                        <span style={{ color: '#2e7d32', fontWeight: '500' }}>
                          Elements disclosed: {priorArtResults.novelty_analysis.closest_reference.elements_disclosed || 0} of {priorArtResults.novelty_analysis.closest_reference.total_elements || '?'}
                        </span>
                      </div>
                      {priorArtResults.novelty_analysis.closest_reference.missing_elements?.length > 0 && (
                        <div style={{ marginTop: '8px' }}>
                          <span style={{ fontWeight: '600', color: '#c62828' }}>Missing elements: </span>
                          <span style={{ color: '#555' }}>{priorArtResults.novelty_analysis.closest_reference.missing_elements.join('; ')}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {priorArtResults.novelty_analysis.element_analysis?.length > 0 && (
                  <div>
                    <h4 style={{ fontSize: '13px', fontWeight: 'bold', color: '#0d47a1', marginBottom: '8px' }}>Element-by-Element Analysis:</h4>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', background: 'white' }}>
                      <thead>
                        <tr style={{ background: '#bbdefb' }}>
                          <th style={{ padding: '8px', textAlign: 'left', borderBottom: '2px solid #1565c0' }}>Claim Element</th>
                          <th style={{ padding: '8px', textAlign: 'center', borderBottom: '2px solid #1565c0', width: '120px' }}>Status</th>
                          <th style={{ padding: '8px', textAlign: 'left', borderBottom: '2px solid #1565c0' }}>References</th>
                        </tr>
                      </thead>
                      <tbody>
                        {priorArtResults.novelty_analysis.element_analysis.map((elem, idx) => {
                          const statusColor = elem.status === 'not_disclosed' ? '#2e7d32' : 
                                             elem.status === 'disclosed_in_multiple' ? '#c62828' : '#f57c00';
                          const statusBg = elem.status === 'not_disclosed' ? '#e8f5e9' : 
                                          elem.status === 'disclosed_in_multiple' ? '#ffebee' : '#fff3e0';
                          const statusText = elem.status === 'not_disclosed' ? 'NOT DISCLOSED' : 
                                            elem.status === 'disclosed_in_multiple' ? 'DISCLOSED (Multiple)' : 'DISCLOSED (One)';
                          return (
                            <tr key={idx} style={{ background: idx % 2 === 0 ? '#fafafa' : 'white' }}>
                              <td style={{ padding: '8px', borderBottom: '1px solid #e0e0e0' }}>{elem.element}</td>
                              <td style={{ padding: '8px', textAlign: 'center', borderBottom: '1px solid #e0e0e0', background: statusBg, color: statusColor, fontWeight: '600', fontSize: '11px' }}>
                                {statusText}
                              </td>
                              <td style={{ padding: '8px', borderBottom: '1px solid #e0e0e0', fontSize: '11px', color: '#666' }}>
                                {elem.disclosing_patents?.length > 0 ? elem.disclosing_patents.join(', ') : '-'}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

                <p style={{ fontSize: '11px', color: '#666', marginTop: '12px', fontStyle: 'italic' }}>
                  {priorArtForm.jurisdiction === 'US' && 'Under 35 U.S.C. §102, a claim is anticipated only if a single prior art reference discloses every element. This analysis is based on the searched dataset only.'}
                  {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && 'Under Art. 54 EPC, a claim lacks novelty only if a single prior art document discloses every feature. This analysis is based on the searched dataset only.'}
                </p>
              </div>
            )}


            {/* 103 Obviousness Risk Pathways */}
            {priorArtResults.risk_pathways && priorArtResults.risk_pathways.pathways?.length > 0 && (
              <div style={{ background: '#ffebee', padding: '16px', borderRadius: '8px', marginBottom: '24px', border: '1px solid #ef9a9a' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <h3 style={{ fontSize: '14px', fontWeight: 'bold', color: '#c62828', margin: 0 }}>
                    {priorArtForm.jurisdiction === 'US' && '103 Obviousness Risk Analysis'}
                    {priorArtForm.jurisdiction === 'UK_EPO' && 'Art. 56 Inventive Step Analysis'}
                    {priorArtForm.jurisdiction === 'EPO_STRICT' && 'Art. 56 Inventive Step (Problem-Solution Approach)'}
                  </h3>
                  <span style={{ 
                    padding: '4px 12px', 
                    borderRadius: '12px', 
                    fontSize: '12px', 
                    fontWeight: 'bold',
                    background: priorArtResults.risk_pathways.risk_level === 'high' ? '#c62828' : 
                               priorArtResults.risk_pathways.risk_level === 'moderate' ? '#ef6c00' : '#388e3c',
                    color: 'white'
                  }}>
                    {priorArtResults.risk_pathways.risk_level?.toUpperCase()} RISK
                  </span>
                </div>
                
                <div style={{ background: '#fce4ec', padding: '12px', borderRadius: '6px', marginBottom: '12px', border: '1px solid #f48fb1' }}>
                  <h5 style={{ fontSize: '11px', fontWeight: 'bold', color: '#c2185b', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Legal Framework</h5>
                  {priorArtForm.jurisdiction === 'US' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>35 U.S.C. §103</strong> - A patent may not be obtained if the differences between the claimed invention and the prior art would have been obvious to a person of ordinary skill in the art.
                      <em style={{ color: '#ad1457' }}> See MPEP §2141 (Examination Guidelines for Obviousness); §2143 (Basic Requirements of a Prima Facie Case). </em>
                      Per <em>KSR Int'l Co. v. Teleflex Inc.</em>, 550 U.S. 398 (2007), obviousness analysis must consider whether a skilled artisan would have been motivated to combine prior art teachings with a reasonable expectation of success.
                    </p>
                  )}
                  {priorArtForm.jurisdiction === 'UK_EPO' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>Article 56 EPC</strong> - An invention shall be considered as involving an inventive step if, having regard to the state of the art, it is not obvious to a person skilled in the art.
                      <em style={{ color: '#ad1457' }}> See EPO Guidelines G-VII (Inventive Step); Problem-Solution Approach. </em>
                      The EPO applies the <em>Problem-Solution Approach</em>: (1) determine closest prior art, (2) identify the objective technical problem, (3) assess whether the skilled person would have arrived at the claimed solution.
                    </p>
                  )}
                  {priorArtForm.jurisdiction === 'EPO_STRICT' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>Article 56 EPC (Strict Problem-Solution)</strong> - An invention involves an inventive step if it is not obvious to the skilled person.
                      <em style={{ color: '#ad1457' }}> See EPO Guidelines G-VII; T 1989/18; Case Law of the Boards of Appeal, I.D. </em>
                      The strict <em>"could-would"</em> test applies: it is not enough that the skilled person <em>could</em> have combined the teachings - they must have been <em>motivated</em> to do so with a reasonable expectation of success.
                    </p>
                  )}
                </div>

                {/* 5-Step Problem-Solution Approach for UK/EPO */}
                {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && priorArtResults.results?.length > 0 && (
                  <div style={{ background: 'white', padding: '16px', borderRadius: '6px', marginBottom: '16px', border: '2px solid #7b1fa2' }}>
                    <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#7b1fa2', marginBottom: '12px' }}>
                      Problem-Solution Approach (EPO Guidelines G-VII, 5)
                    </h4>
                    
                    {(() => {
                      const closestArt = priorArtResults.results[0];
                      const features = priorArtForm.key_features?.filter(f => f.trim()) || [];
                      const matrix = closestArt?.claim_feature_matrix || {};
                      const notDisclosed = features.filter((f, idx) => {
                        const featureData = matrix[(idx + 1).toString()] || {};
                        return featureData.disclosed === 'no' || !featureData.disclosed;
                      });
                      const partiallyDisclosed = features.filter((f, idx) => {
                        const featureData = matrix[(idx + 1).toString()] || {};
                        return featureData.disclosed === 'partial';
                      });
                      const distinguishing = [...notDisclosed, ...partiallyDisclosed];
                      
                      return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          {/* Step 1 */}
                          <div style={{ background: '#f3e5f5', padding: '12px', borderRadius: '6px', borderLeft: '4px solid #7b1fa2' }}>
                            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#7b1fa2', marginBottom: '6px' }}>
                              STEP 1: Closest Prior Art
                            </div>
                            <div style={{ fontSize: '13px', color: '#333' }}>
                              <a href={'https://patents.google.com/patent/US' + closestArt?.patent_number} target="_blank" rel="noopener noreferrer" style={{ color: '#1565c0', fontWeight: '600' }}>
                                US{closestArt?.patent_number}
                              </a>
                              <span style={{ marginLeft: '8px', color: '#666' }}>- {closestArt?.title}</span>
                            </div>
                            <div style={{ fontSize: '11px', color: '#666', marginTop: '4px', fontStyle: 'italic' }}>
                              Selected as closest prior art based on: same technical field, similar purpose, most features in common.
                            </div>
                          </div>

                          {/* Step 2 */}
                          <div style={{ background: '#e8f5e9', padding: '12px', borderRadius: '6px', borderLeft: '4px solid #388e3c' }}>
                            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#388e3c', marginBottom: '6px' }}>
                              STEP 2: Distinguishing Features
                            </div>
                            <div style={{ fontSize: '13px', color: '#333' }}>
                              {distinguishing.length > 0 ? (
                                <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                  {distinguishing.slice(0, 5).map((feature, i) => (
                                    <li key={i} style={{ marginBottom: '4px' }}>{feature}</li>
                                  ))}
                                </ul>
                              ) : (
                                <span style={{ color: '#c62828' }}>All claimed features appear to be disclosed in the closest prior art. Novelty may be at risk.</span>
                              )}
                            </div>
                          </div>

                          {/* Step 3 */}
                          <div style={{ background: '#e3f2fd', padding: '12px', borderRadius: '6px', borderLeft: '4px solid #1976d2' }}>
                            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#1976d2', marginBottom: '6px' }}>
                              STEP 3: Technical Effect
                            </div>
                            <div style={{ fontSize: '13px', color: '#333' }}>
                              {distinguishing.length > 0 ? (
                                priorArtResults.psa_analysis?.technical_effect?.primary_effect ? (
                                  <span><strong>Primary Effect:</strong> {priorArtResults.psa_analysis.technical_effect.primary_effect}</span>
                                ) : (
                                  <span>The distinguishing feature(s) provide the technical effect of: <em style={{ color: '#555' }}>improved performance, efficiency, or functionality in the specific technical application as described in the invention disclosure.</em></span>
                                )
                              ) : (
                                <span style={{ color: '#666', fontStyle: 'italic' }}>Technical effect analysis requires distinguishing features to be identified.</span>
                              )}
                            </div>
                          </div>

                          {/* Step 4 */}
                          <div style={{ background: '#fff3e0', padding: '12px', borderRadius: '6px', borderLeft: '4px solid #f57c00' }}>
                            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#f57c00', marginBottom: '6px' }}>
                              STEP 4: Objective Technical Problem
                            </div>
                            <div style={{ fontSize: '13px', color: '#333' }}>
                              {distinguishing.length > 0 ? (
                                priorArtResults.psa_analysis?.objective_technical_problem?.formulation ? (
                                  <span>{priorArtResults.psa_analysis.objective_technical_problem.formulation}</span>
                                ) : (
                                  <span>Starting from <strong>US{closestArt?.patent_number}</strong>, the objective technical problem can be formulated as: <em style={{ color: '#555' }}>"How to modify or adapt the closest prior art to achieve the technical effect provided by the distinguishing features."</em></span>
                                )
                              ) : (
                                <span style={{ color: '#666', fontStyle: 'italic' }}>Problem formulation requires distinguishing features to be identified.</span>
                              )}
                            </div>
                          </div>

                          {/* Step 5 */}
                          <div style={{ background: '#ffebee', padding: '12px', borderRadius: '6px', borderLeft: '4px solid #c62828' }}>
                            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#c62828', marginBottom: '6px' }}>
                              STEP 5: Could-Would Analysis
                            </div>
                            <div style={{ fontSize: '13px', color: '#333', lineHeight: '1.6' }}>
                              <div style={{ marginBottom: '8px' }}>
                                <strong style={{ color: '#1976d2' }}>COULD:</strong> {priorArtResults.psa_analysis?.could_would_analysis?.could_reasoning 
                                  ? <span>{priorArtResults.psa_analysis.could_would_analysis.could_reasoning}</span>
                                  : priorArtResults.risk_pathways?.pathways?.length > 0 
                                    ? <span>The skilled person <em>could</em> technically combine the teachings of the identified references.</span>
                                    : <span>No obvious combination pathway identified in the searched dataset.</span>
                                }
                              </div>
                              <div>
                                <strong style={{ color: '#388e3c' }}>WOULD:</strong> {priorArtResults.psa_analysis?.could_would_analysis?.would_reasoning
                                  ? <span>{priorArtResults.psa_analysis.could_would_analysis.would_reasoning}</span>
                                  : priorArtResults.risk_pathways?.risk_level === 'high'
                                    ? <span style={{ color: '#c62828' }}>Based on the prior art analysis, an examiner may argue the skilled person <em>would have been motivated</em> to make the combination. <strong>Higher combination risk identified.</strong></span>
                                    : priorArtResults.risk_pathways?.risk_level === 'moderate'
                                      ? <span style={{ color: '#f57c00' }}>Motivation to combine is arguable. <strong>Moderate combination risk identified.</strong> Arguments distinguishing the technical problem or unexpected results may be required.</span>
                                      : <span style={{ color: '#388e3c' }}>No clear motivation to combine was identified in the searched dataset. <strong>Further analysis required</strong> — this assessment is based on USPTO 2021-2024 data only.</span>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })()}

                    <p style={{ fontSize: '10px', color: '#666', marginTop: '12px', marginBottom: 0, fontStyle: 'italic' }}>
                      This Problem-Solution analysis follows EPO Guidelines G-VII, 5. The objective technical problem must be formulated without hindsight. See T 1989/18 for application of the could-would approach.
                    </p>
                  </div>
                )}

                <p style={{ fontSize: '13px', color: '#555', marginBottom: '16px', lineHeight: '1.5' }}>
                  {priorArtResults.risk_pathways.summary}
                </p>

                {priorArtResults.risk_pathways.pathways.map((pathway, idx) => (
                  <div key={idx} style={{ background: 'white', padding: '12px', borderRadius: '6px', marginBottom: '12px', border: '1px solid #ffcdd2' }}>
                    <div style={{ fontWeight: '600', color: '#c62828', marginBottom: '8px', fontSize: '13px' }}>
                      Pathway {idx + 1}: {pathway.combination_name || `${pathway.primary_ref} + ${pathway.secondary_refs?.join(' + ')}`}
                    </div>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '12px', marginBottom: '8px' }}>
                      <div>
                        <span style={{ fontWeight: '600', color: '#333' }}>Primary Reference: </span>
                        <a href={'https://patents.google.com/patent/US' + pathway.primary_ref?.replace('US', '')} target="_blank" rel="noopener noreferrer" style={{ color: '#1565c0' }}>
                          {pathway.primary_ref}
                        </a>
                        {pathway.elements_from_primary?.length > 0 && (
                          <div style={{ color: '#666', marginTop: '4px' }}>
                            Teaches: {pathway.elements_from_primary.join(', ')}
                          </div>
                        )}
                      </div>
                      <div>
                        <span style={{ fontWeight: '600', color: '#333' }}>Secondary Reference(s): </span>
                        {pathway.secondary_refs?.map((ref, i) => (
                          <span key={i}>
                            <a href={'https://patents.google.com/patent/US' + ref?.replace('US', '')} target="_blank" rel="noopener noreferrer" style={{ color: '#1565c0' }}>
                              {ref}
                            </a>
                            {i < pathway.secondary_refs.length - 1 ? ', ' : ''}
                          </span>
                        ))}
                        {pathway.elements_from_secondary?.length > 0 && (
                          <div style={{ color: '#666', marginTop: '4px' }}>
                            Teaches: {pathway.elements_from_secondary.join(', ')}
                          </div>
                        )}
                      </div>
                    </div>

                    {pathway.missing_elements?.length > 0 && (
                      <div style={{ background: '#e8f5e9', padding: '8px', borderRadius: '4px', marginBottom: '8px', fontSize: '12px' }}>
                        <span style={{ fontWeight: '600', color: '#2e7d32' }}>Still NOT Taught: </span>
                        <span style={{ color: '#388e3c' }}>{pathway.missing_elements.join(', ')}</span>
                      </div>
                    )}

                    <div style={{ fontSize: '12px', marginBottom: '8px' }}>
                      <span style={{ fontWeight: '600', color: '#c62828' }}>Examiner Rationale: </span>
                      <span style={{ color: '#555' }}>{pathway.examiner_rationale}</span>
                    </div>

                    {pathway.potential_counter && (
                      <div style={{ fontSize: '12px', background: '#e3f2fd', padding: '8px', borderRadius: '4px' }}>
                        <span style={{ fontWeight: '600', color: '#1565c0' }}>Potential Counter-Argument: </span>
                        <span style={{ color: '#555' }}>{pathway.potential_counter}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* CLAIM CONSTRUCTION RISKS - Attorney Section */}
            {priorArtResults.claim_construction && priorArtResults.claim_construction.risks?.length > 0 && (
              <div style={{ background: '#fff3e0', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '2px solid #ff9800' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                  <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#e65100', margin: 0 }}>
                    {priorArtForm.jurisdiction === 'US' && 'Claim Construction Risks (§112)'}
                    {priorArtForm.jurisdiction === 'UK_EPO' && 'Claim Clarity & Support Risks (Art. 84 EPC)'}
                    {priorArtForm.jurisdiction === 'EPO_STRICT' && 'Claim Clarity, Support & Added Matter (Art. 84/123(2) EPC)'}
                  </h3>
                  <span style={{
                    padding: '6px 16px',
                    borderRadius: '20px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    background: priorArtResults.claim_construction.overall_risk === 'high' ? '#c62828' :
                               priorArtResults.claim_construction.overall_risk === 'moderate' ? '#f57c00' : '#388e3c',
                    color: 'white'
                  }}>
                    {priorArtResults.claim_construction.overall_risk?.toUpperCase() || 'UNKNOWN'} RISK
                  </span>
                </div>

                <div style={{ background: '#fff8e1', padding: '12px', borderRadius: '6px', marginBottom: '12px', border: '1px solid #ffcc80' }}>
                  <h5 style={{ fontSize: '11px', fontWeight: 'bold', color: '#f57c00', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Legal Framework</h5>
                  {priorArtForm.jurisdiction === 'US' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>35 U.S.C. §112</strong> - Claims must particularly point out and distinctly claim the subject matter of the invention. The specification must enable one skilled in the art to make and use the invention.
                      <em style={{ color: '#e65100' }}> See MPEP §2171 (Definiteness); §2173 (Claim Interpretation). </em>
                      Under <em>Nautilus v. Biosig</em>, 572 U.S. 898 (2014), claims must inform skilled artisans of the scope of the invention with reasonable certainty.
                    </p>
                  )}
                  {priorArtForm.jurisdiction === 'UK_EPO' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>Article 84 EPC</strong> - Claims shall define the matter for which protection is sought, be clear and concise, and be supported by the description.
                      <em style={{ color: '#e65100' }}> See EPO Guidelines F-IV (Claims); G-VI (Sufficiency). </em>
                      Per <em>T 68/85</em>, claims must be clear both in isolation and when read with the description. Support requires the full scope to be derivable from the description.
                    </p>
                  )}
                  {priorArtForm.jurisdiction === 'EPO_STRICT' && (
                    <p style={{ fontSize: '11px', color: '#444', margin: 0, lineHeight: '1.5' }}>
                      <strong>Articles 84 & 123(2) EPC</strong> - Claims must be clear, supported, and must not extend beyond the original disclosure (no added matter).
                      <em style={{ color: '#e65100' }}> See EPO Guidelines H-IV (Amendments); Case Law I.E (Added Matter). </em>
                      Per <em>T 201/83</em> and the <em>"gold standard"</em>, amendments must be directly and unambiguously derivable from the application as filed. <em>G 2/10</em> confirms strict added matter assessment.
                    </p>
                  )}
                </div>

                {priorArtResults.claim_construction.summary && (
                  <div style={{ background: 'white', padding: '12px', borderRadius: '6px', marginBottom: '16px', border: '1px solid #ffcc80' }}>
                    <p style={{ fontSize: '13px', color: '#333', lineHeight: '1.6', margin: 0 }}>
                      {priorArtResults.claim_construction.summary}
                    </p>
                  </div>
                )}

                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', background: 'white' }}>
                  <thead>
                    <tr style={{ background: '#ffe0b2' }}>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ff9800', width: '20%' }}>Term/Phrase</th>
                      <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #ff9800', width: '15%' }}>Risk Type</th>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ff9800', width: '30%' }}>Examiner Concern</th>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #ff9800', width: '35%' }}>Recommendation</th>
                    </tr>
                  </thead>
                  <tbody>
                    {priorArtResults.claim_construction.risks.map((risk, idx) => {
                      const riskTypeColors = {
                        'ambiguity': { bg: '#fff3e0', color: '#e65100' },
                        'functional_language': { bg: '#fce4ec', color: '#c2185b' },
                        'relative_term': { bg: '#e8f5e9', color: '#2e7d32' },
                        'breadth': { bg: '#ffebee', color: '#c62828' },
                        'antecedent': { bg: '#e3f2fd', color: '#1565c0' },
                        'definition_needed': { bg: '#f3e5f5', color: '#7b1fa2' }
                      };
                      const typeStyle = riskTypeColors[risk.risk_type] || { bg: '#f5f5f5', color: '#666' };
                      const riskTypeLabel = risk.risk_type?.replace('_', ' ').toUpperCase() || 'UNKNOWN';
                      
                      return (
                        <tr key={idx} style={{ background: idx % 2 === 0 ? '#fafafa' : 'white' }}>
                          <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600', color: '#333' }}>
                            "{risk.term}"
                          </td>
                          <td style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>
                            <span style={{ 
                              padding: '3px 8px', 
                              borderRadius: '4px', 
                              fontSize: '10px', 
                              fontWeight: 'bold',
                              background: typeStyle.bg,
                              color: typeStyle.color
                            }}>
                              {riskTypeLabel}
                            </span>
                          </td>
                          <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontSize: '11px', color: '#555', lineHeight: '1.5' }}>
                            {risk.concern}
                          </td>
                          <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontSize: '11px', color: '#1565c0', lineHeight: '1.5' }}>
                            {risk.recommendation}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <p style={{ fontSize: '11px', color: '#666', marginTop: '12px', fontStyle: 'italic' }}>
                  Claim construction analysis identifies terms that may face examiner scrutiny or require additional specification support. Address high-priority items before filing.
                </p>
              </div>
            )}


            {/* Feature Matrix Summary - Attorney-Ready Overview (US only) */}
            {priorArtForm.jurisdiction === 'US' && priorArtForm.key_features?.filter(f => f.trim()).length > 0 && priorArtResults.results?.some(p => p.claim_feature_matrix && Object.keys(p.claim_feature_matrix).length > 0) && (
              <div style={{ background: '#f3e5f5', padding: '16px', borderRadius: '8px', marginBottom: '24px', border: '1px solid #ce93d8', overflowX: 'auto' }}>
                <h3 style={{ fontSize: '14px', fontWeight: 'bold', color: '#7b1fa2', marginBottom: '12px' }}>Feature Matrix Summary - Top References</h3>
                <p style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>Y = Disclosed, P = Partial, N = Not Disclosed</p>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', minWidth: '600px' }}>
                  <thead>
                    <tr style={{ background: '#e1bee7' }}>
                      <th style={{ padding: '8px', textAlign: 'left', borderBottom: '2px solid #ce93d8', fontWeight: '600' }}>Feature</th>
                      <th style={{ padding: '8px', textAlign: 'center', borderBottom: '2px solid #ce93d8', fontWeight: '600', background: '#c8e6c9' }}>Invention</th>
                      {priorArtResults.results.slice(0, 6).map((patent, idx) => (
                        <th key={idx} style={{ padding: '8px', textAlign: 'center', borderBottom: '2px solid #ce93d8', fontWeight: '600', maxWidth: '120px' }}>
                          <a href={'https://patents.google.com/patent/US' + patent.patent_number} target="_blank" rel="noopener noreferrer" style={{ color: '#7b1fa2', textDecoration: 'none' }}>
                            US{patent.patent_number}
                          </a>
                          <br/>
                          {priorArtForm.jurisdiction === 'US' && <span style={{ fontSize: '10px', color: '#666' }}>({patent.similarity_score}%)</span>}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {priorArtForm.key_features.filter(f => f.trim()).map((feature, featureIdx) => (
                      <tr key={featureIdx} style={{ background: featureIdx % 2 === 0 ? '#fafafa' : 'white' }}>
                        <td style={{ padding: '8px', borderBottom: '1px solid #e0e0e0', fontWeight: '500' }}>{feature}</td>
                        <td style={{ padding: '8px', textAlign: 'center', borderBottom: '1px solid #e0e0e0', background: '#c8e6c9', fontWeight: 'bold', color: '#2e7d32' }}>Y</td>
                        {priorArtResults.results.slice(0, 6).map((patent, patentIdx) => {
                          const matrix = patent.claim_feature_matrix || {};
                          const featureNum = (featureIdx + 1).toString();
                          const featureData = matrix[featureNum] || {};
                          const disclosure = featureData.disclosed || 'no';
                          const citation = featureData.citation || null;
                          const displayVal = disclosure === 'yes' ? 'Y' : disclosure === 'partial' ? 'P' : 'N';
                          const bgColor = disclosure === 'yes' ? '#ffcdd2' : disclosure === 'partial' ? '#fff3e0' : '#e8f5e9';
                          const textColor = disclosure === 'yes' ? '#c62828' : disclosure === 'partial' ? '#ef6c00' : '#388e3c';
                          return (
                            <td key={patentIdx} style={{ padding: '4px', textAlign: 'center', borderBottom: '1px solid #e0e0e0', background: bgColor, color: textColor, fontWeight: 'bold', verticalAlign: 'top' }}>
                              <div>{displayVal}</div>
                              {citation && (
                                <div style={{ fontSize: '9px', fontWeight: 'normal', color: '#666', marginTop: '2px' }}>
                                  {citation.length > 20 ? citation.substring(0, 20) + '...' : citation}
                                </div>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p style={{ fontSize: '11px', color: '#666', marginTop: '8px', fontStyle: 'italic' }}>
                  This matrix shows the top 6 references. Red (Y) = feature disclosed and may affect novelty. Orange (P) = partially disclosed. Green (N) = not disclosed.
                  Truncated citations shown above; full paragraph and figure references available in the detailed Claim Charts below.
                </p>
              </div>
            )}
            {/* SHORTLIST - Top Most Relevant References (US only) */}
            {priorArtForm.jurisdiction === 'US' && priorArtResults.results?.filter(p => p.similarity_score >= 40).length > 0 && (
              <div style={{ background: '#fff8e1', padding: '16px', borderRadius: '8px', marginBottom: '24px', border: '2px solid #ffb300' }}>
                <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#ff6f00', marginBottom: '12px' }}>
                  Shortlist: Most Relevant References ({priorArtResults.results.filter(p => p.similarity_score >= 40).length} patents)
                </h3>
                <p style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>
                  {priorArtForm.jurisdiction === 'US' 
                  ? 'These references scored 40%+ similarity and warrant closer attorney review.'
                  : 'These references warrant closer attorney review based on feature overlap analysis.'}
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px' }}>
                  {priorArtResults.results.filter(p => p.similarity_score >= 40).slice(0, 6).map((patent) => {
                    const scoreColor = patent.similarity_score >= 80 ? '#d32f2f' : patent.similarity_score >= 60 ? '#f57c00' : '#fbc02d';
                    return (
                      <div key={patent.patent_number} style={{ background: 'white', padding: '12px', borderRadius: '6px', border: `2px solid ${scoreColor}` }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <a href={'https://patents.google.com/patent/US' + patent.patent_number} target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'bold', color: '#1565c0', textDecoration: 'none' }}>
                            US{patent.patent_number}
                          </a>
                          {priorArtForm.jurisdiction === 'US' 
                        ? <span style={{ fontSize: '18px', fontWeight: 'bold', color: scoreColor }}>{patent.similarity_score}%</span>
                        : <span style={{ fontSize: '14px', fontWeight: 'bold', color: scoreColor }}>Review</span>}
                        </div>
                        <p style={{ fontSize: '12px', color: '#333', margin: 0, lineHeight: '1.4' }}>{patent.title?.substring(0, 80)}{patent.title?.length > 80 ? '...' : ''}</p>
                        <p style={{ fontSize: '11px', color: '#666', margin: '4px 0 0 0' }}>{patent.assignee}</p>
                        {patent.cpc_codes && patent.cpc_codes.length > 0 && (
                          <p style={{ fontSize: '10px', color: '#888', margin: '4px 0 0 0' }}>
                            CPC: {patent.cpc_codes.slice(0, 3).join(', ')}{patent.cpc_codes.length > 3 ? '...' : ''}
                          </p>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* RELEVANT RESULTS (40%+ similarity) - US only */}
            {priorArtForm.jurisdiction === 'US' && priorArtResults.results?.filter(p => p.similarity_score >= 40).length > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#333', marginBottom: '16px' }}>
                  Relevant Prior Art ({priorArtResults.results.filter(p => p.similarity_score >= 40).length} references)
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {priorArtResults.results.filter(p => p.similarity_score >= 40).map((patent) => {
                    const scoreColor = patent.similarity_score >= 80 ? '#d32f2f' : patent.similarity_score >= 60 ? '#f57c00' : '#fbc02d';
                    const categoryIcon = patent.relevance_category === 'X' ? '[X]' : patent.relevance_category === 'Y' ? '[Y]' : '';
                
                    return (
                      <div key={patent.patent_number} style={{ border: `3px solid ${scoreColor}`, borderRadius: '8px', padding: '20px', background: 'white' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
                      <div>
                        <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1d2934', marginBottom: '4px' }}>
                          {categoryIcon} US{patent.patent_number}
                        </h3>
                        <p style={{ fontSize: '16px', color: '#333', fontWeight: '500' }}>{patent.title}</p>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        {priorArtForm.jurisdiction === 'US' ? (
                          <>
                            <div style={{ fontSize: '28px', fontWeight: 'bold', color: scoreColor }}>{patent.similarity_score}%</div>
                            <div style={{ fontSize: '12px', color: '#666' }}>Similarity</div>
                          </>
                        ) : (
                          <div style={{ fontSize: '16px', fontWeight: 'bold', color: scoreColor }}>Relevant</div>
                        )}
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: '16px', marginBottom: '12px', fontSize: '14px', color: '#666', flexWrap: 'wrap' }}>
                      <span style={{ 
                        background: patent.source_type === 'Pending Application' ? '#e8f5e9' : '#e3f2fd', 
                        color: patent.source_type === 'Pending Application' ? '#2e7d32' : '#1565c0',
                        padding: '2px 8px', 
                        borderRadius: '4px',
                        fontWeight: '600',
                        fontSize: '12px'
                      }}>
                        {patent.source_type || 'Granted Patent'}
                      </span>
                      <span>{patent.source_type === 'Pending Application' ? 'Published' : 'Granted'}: <strong>{patent.relevant_date || patent.grant_date || 'N/A'}</strong></span>
                      <span>Assignee: {patent.assignee}</span>
                      {patent.assignee_portfolio && patent.assignee_portfolio.total_portfolio > 0 && (
                        <span style={{ background: '#fff3e0', padding: '2px 6px', borderRadius: '3px', fontSize: '11px', color: '#e65100' }}>
                          Portfolio: {patent.assignee_portfolio.total_portfolio.toLocaleString()} ({patent.assignee_portfolio.granted_patents.toLocaleString()} granted + {patent.assignee_portfolio.pending_applications.toLocaleString()} pending)
                        </span>
                      )}
                      <span>Status: {patent.status}</span>
                    </div>
                    
                    {(patent.forward_citations > 0 || patent.backward_citations > 0) && (
                      <div style={{ display: 'flex', gap: '16px', marginBottom: '12px', fontSize: '13px', background: '#f0f7ff', padding: '8px 12px', borderRadius: '4px' }}>
                        <span style={{ color: '#1565c0' }}>
                          <strong>{patent.forward_citations || 0}</strong> citing patents
                        </span>
                        <span style={{ color: '#666' }}>|</span>
                        <span style={{ color: '#555' }}>
                          Cites <strong>{patent.backward_citations || 0}</strong> US patents
                        </span>
                        {patent.foreign_citations > 0 && (
                          <>
                            <span style={{ color: '#666' }}>|</span>
                            <span style={{ color: '#555' }}>
                              <strong>{patent.foreign_citations}</strong> foreign refs
                            </span>
                          </>
                        )}
                      </div>
                    )}

                    {patent.features_disclosed?.length > 0 && (
                      <div style={{ background: '#e8f5e9', padding: '12px', borderRadius: '4px', marginBottom: '12px' }}>
                        <strong style={{ color: '#2e7d32' }}>Features Disclosed:</strong> {Array.isArray(patent.features_disclosed) ? patent.features_disclosed.join(', ') : patent.features_disclosed}
                      </div>
                    )}

                    {patent.claim_feature_matrix && Object.keys(patent.claim_feature_matrix).length > 0 && priorArtForm.key_features?.filter(f => f.trim()).length > 0 && (
                      <div style={{ background: '#f3e5f5', padding: '12px', borderRadius: '4px', marginBottom: '12px', border: '1px solid #ce93d8' }}>
                        <strong style={{ color: '#7b1fa2', fontSize: '13px', display: 'block', marginBottom: '8px' }}>Claim Chart - Feature Analysis:</strong>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                          <thead>
                            <tr style={{ background: '#e1bee7' }}>
                              <th style={{ padding: '6px 8px', textAlign: 'left', borderBottom: '1px solid #ce93d8' }}>Your Feature</th>
                              <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #ce93d8', width: '80px' }}>Disclosed?</th>
                              <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #ce93d8', width: '70px' }}>Claim Ref</th>
                              <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #ce93d8', width: '100px' }}>Citation</th>
                              <th style={{ padding: '6px 8px', textAlign: 'left', borderBottom: '1px solid #ce93d8' }}>Notes</th>
                            </tr>
                          </thead>
                          <tbody>
                            {priorArtForm.key_features.filter(f => f.trim()).map((feature, idx) => {
                              const featureNum = (idx + 1).toString();
                              const matrix = patent.claim_feature_matrix[featureNum] || {};
                              const disclosed = matrix.disclosed || 'no';
                              const disclosedColor = disclosed === 'yes' ? '#c62828' : disclosed === 'partial' ? '#ef6c00' : '#388e3c';
                              const disclosedBg = disclosed === 'yes' ? '#ffebee' : disclosed === 'partial' ? '#fff3e0' : '#e8f5e9';
                              const disclosedIcon = disclosed === 'yes' ? '!!' : disclosed === 'partial' ? '~' : '--';
                              return (
                                <tr key={idx} style={{ background: idx % 2 === 0 ? '#fafafa' : 'white' }}>
                                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #e0e0e0' }}>{feature}</td>
                                  <td style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #e0e0e0', background: disclosedBg, color: disclosedColor, fontWeight: 'bold' }}>
                                    {disclosedIcon} {disclosed.toUpperCase()}
                                  </td>
                                  <td style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>
                                    {matrix.claim_ref ? `Claim ${matrix.claim_ref}` : '-'}
                                  </td>
                                  <td style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #e0e0e0', fontSize: '11px', color: '#1565c0', fontWeight: '500' }}>
                                    {matrix.citation || '-'}
                                  </td>
                                  <td style={{ padding: '6px 8px', borderBottom: '1px solid #e0e0e0', fontSize: '11px', color: '#666' }}>
                                    {matrix.notes || '-'}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Full Independent Claim - Expandable */}
                    {patent.claims_text && (
                      <details style={{ background: '#e3f2fd', borderRadius: '4px', marginBottom: '12px', border: '1px solid #90caf9' }}>
                        <summary style={{ padding: '12px', cursor: 'pointer', fontWeight: '600', color: '#1565c0', fontSize: '13px' }}>
                          Full Independent Claim (Claim 1) - Click to expand
                        </summary>
                        <div style={{ padding: '12px', paddingTop: '0', background: '#f5f5f5', borderTop: '1px solid #90caf9' }}>
                          <p style={{ fontSize: '12px', color: '#333', lineHeight: '1.6', whiteSpace: 'pre-wrap', fontFamily: 'Georgia, serif', margin: 0 }}>
                            {(() => {
                              // Extract Claim 1 (independent claim)
                              const claim1Regex = /Claim\s*00001:([\s\S]*?)(?=Claim\s*\d{5}:|$)/i;
                              const match = patent.claims_text.match(claim1Regex);
                              if (match && match[1]) {
                                let text = match[1].replace(/^\s*1\.\s*/, '').trim();
                                return text || 'Claim 1 text not available in structured format.';
                              }
                              // Fallback: try to find "1." pattern at start
                              const fallbackRegex = /^\s*1\.\s*([\s\S]*?)(?=\n\s*2\.|$)/;
                              const fallbackMatch = patent.claims_text.match(fallbackRegex);
                              if (fallbackMatch && fallbackMatch[1]) {
                                return fallbackMatch[1].trim();
                              }
                              // Last fallback: show first 2000 chars
                              return patent.claims_text.substring(0, 2000) + (patent.claims_text.length > 2000 ? '...' : '');
                            })()}
                          </p>
                          
                          <a
                            href={'https://patents.google.com/patent/US' + patent.patent_number + '/en#claims'}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: 'inline-block', marginTop: '8px', fontSize: '11px', color: '#1565c0' }}
                          >
                            View all claims on Google Patents →
                          </a>
                        </div>
                      </details>
                    )}

                    <p style={{ fontSize: '14px', color: '#474f58', lineHeight: '1.6', marginBottom: '12px' }}>
                      {patent.relevance_explanation}
                    </p>

                    {patent.key_claims && patent.key_claims.length > 0 && 
                     patent.key_claims.some(c => c && !c.toLowerCase().includes('not applicable') && !c.toLowerCase().includes('no specific') && !c.toLowerCase().includes('none identified') && !c.toLowerCase().includes('n/a')) && (
                      <div style={{ background: '#fff8e1', padding: '12px', borderRadius: '4px', marginBottom: '12px', border: '1px solid #ffe082' }}>
                        <strong style={{ color: '#f57c00', fontSize: '13px' }}>Key Claims Identified:</strong>
                        {patent.key_claims
                          .filter(c => c && !c.toLowerCase().includes('not applicable') && !c.toLowerCase().includes('no specific') && !c.toLowerCase().includes('none identified') && !c.toLowerCase().includes('n/a'))
                          .map((claimNum, idx) => {
                            // Extract the actual claim text from claims_text
                            let claimText = '';
                            if (patent.claims_text) {
                              const claimNumClean = claimNum.toString().replace(/[^0-9]/g, '');
                              const paddedNum = claimNumClean.padStart(5, '0');
                              
                              // Find this specific claim using Claim XXXXX: pattern
                              const claimRegex = new RegExp('Claim\\s*' + paddedNum + ':([\\s\\S]*?)(?=Claim\\s*\\d{5}:|$)', 'i');
                              const match = patent.claims_text.match(claimRegex);
                              
                              if (match && match[1]) {
                                // Clean up: remove leading "1. " and trim
                                let text = match[1].replace(/^\s*\d+\.\s*/, '').trim();
                                if (text.length > 400) {
                                  text = text.substring(0, 400) + '...';
                                }
                                claimText = text;
                              }
                            }

                            return (
                              <div key={idx} style={{ marginTop: '8px', padding: '8px', background: '#fffde7', borderRadius: '4px', borderLeft: '3px solid #f57c00' }}>
                                <a 
                                  href={'https://patents.google.com/patent/US' + patent.patent_number + '/en#claims'} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  style={{ color: '#e65100', fontWeight: 'bold', textDecoration: 'none' }}
                                >
                                  Claim {claimNum} (US{patent.patent_number})
                                </a>:
                                {claimText ? (
                                  <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#555', lineHeight: '1.5' }}>{claimText}</p>
                                ) : (
                                  <span style={{ marginLeft: '8px', fontSize: '12px', color: '#888' }}>Identified as relevant</span>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    )}

                    <a
                      href={'https://patents.google.com/patent/US' + patent.patent_number}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: 'inline-block', background: '#53dafc', color: 'white', padding: '8px 16px', borderRadius: '4px', textDecoration: 'none', fontSize: '14px', fontWeight: '600' }}
                    >
                      View Full Patent →
                    </a>
                  </div>
                );
              })}
                </div>
              </div>
            )}

            {/* EXCLUDED/BACKGROUND RESULTS (<40% similarity) - US only */}
            {priorArtForm.jurisdiction === 'US' && priorArtResults.results?.filter(p => p.similarity_score > 0 && p.similarity_score < 40).length > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <details style={{ background: '#f5f5f5', borderRadius: '8px', border: '1px solid #ddd' }}>
                  <summary style={{ padding: '16px', cursor: 'pointer', fontWeight: 'bold', color: '#666', fontSize: '14px' }}>
                    Background/Excluded Results ({priorArtResults.results.filter(p => p.similarity_score > 0 && p.similarity_score < 40).length} references with &lt;40% similarity)
                    <span style={{ fontWeight: 'normal', marginLeft: '8px', fontSize: '12px' }}>- Click to expand</span>
                  </summary>
                  <div style={{ padding: '16px', paddingTop: '0' }}>
                    <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
                      These references were reviewed but determined to be only tangentially related or from different technical domains.
                    </p>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '12px' }}>
                      {priorArtResults.results.filter(p => p.similarity_score > 0 && p.similarity_score < 40).map((patent) => (
                        <div key={patent.patent_number} style={{ background: 'white', padding: '12px', borderRadius: '6px', border: '1px solid #e0e0e0' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <a href={'https://patents.google.com/patent/US' + patent.patent_number} target="_blank" rel="noopener noreferrer" style={{ fontWeight: '600', color: '#1565c0', textDecoration: 'none', fontSize: '13px' }}>
                              US{patent.patent_number}
                            </a>
                            {priorArtForm.jurisdiction === 'US' && <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#757575' }}>{patent.similarity_score}%</span>}
                          </div>
                          <p style={{ fontSize: '12px', color: '#333', margin: 0, lineHeight: '1.4' }}>{patent.title?.substring(0, 100)}{patent.title?.length > 100 ? '...' : ''}</p>
                          <p style={{ fontSize: '11px', color: '#888', margin: '4px 0 0 0' }}>{patent.assignee} - {patent.source_type}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </details>
              </div>
            )}



            {/* PART 3: OPINION & RECOMMENDATIONS - UK/EPO Structure (Issue 2) */}
            {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && (
            <div style={{ background: '#2e7d32', padding: '12px 20px', borderRadius: '4px', marginBottom: '16px' }}>
              <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: 'white', margin: 0, letterSpacing: '2px' }}>
                PART 3: OPINION & RECOMMENDATIONS
              </h2>
            </div>
            )}

            {/* PRELIMINARY PATENTABILITY OPINION - Formal Attorney Conclusion */}
            {priorArtResults.preliminary_opinion && (
              <div style={{ background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)', padding: '24px', borderRadius: '8px', marginBottom: '24px', color: 'white', border: '3px solid #0d47a1' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>
                    Preliminary Patentability Opinion
                  </h2>
                  <span style={{
                    padding: '8px 20px',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    background: priorArtResults.preliminary_opinion.overall_assessment === 'preliminary_patentable' ? '#2e7d32' :
                               priorArtResults.preliminary_opinion.overall_assessment === 'patentable_with_risks' ? '#f57c00' : '#c62828',
                    color: 'white',
                    border: '2px solid white'
                  }}>
                    {priorArtResults.preliminary_opinion.overall_assessment === 'preliminary_patentable' ? 'PRELIMINARY PATENTABLE' :
                     priorArtResults.preliminary_opinion.overall_assessment === 'patentable_with_risks' ? 'PATENTABLE WITH RISKS' : 'SIGNIFICANT CONCERNS'}
                  </span>
                </div>

                {/* Formal Opinion */}
                <div style={{ background: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', marginBottom: '20px', color: '#333' }}>
                  <p style={{ fontSize: '14px', lineHeight: '1.8', margin: 0, fontStyle: 'italic', color: '#1a237e' }}>
                    {priorArtResults.preliminary_opinion.formal_opinion}
                  </p>
                </div>

                {/* PATENTABILITY PROSPECTS BOX - UK/EPO Only */}
                {(priorArtForm.jurisdiction === 'UK_EPO' || priorArtForm.jurisdiction === 'EPO_STRICT') && (
                  <div style={{ background: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', marginBottom: '20px', color: '#333' }}>
                    <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#1a237e', marginBottom: '16px', borderBottom: '2px solid #1a237e', paddingBottom: '8px' }}>
                      PATENTABILITY PROSPECTS
                    </h4>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td style={{ padding: '10px 0', fontWeight: '500' }}>Novelty (Art. 54 EPC)</td>
                          <td style={{ padding: '10px 0', textAlign: 'right' }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: '4px',
                              fontWeight: 'bold',
                              fontSize: '12px',
                              background: priorArtResults.novelty_analysis?.conclusion === 'novel' ? '#e8f5e9' :
                                         priorArtResults.novelty_analysis?.conclusion === 'anticipated' ? '#ffebee' : '#fff3e0',
                              color: priorArtResults.novelty_analysis?.conclusion === 'novel' ? '#2e7d32' :
                                    priorArtResults.novelty_analysis?.conclusion === 'anticipated' ? '#c62828' : '#f57c00'
                            }}>
                              {(priorArtResults.novelty_analysis?.conclusion === 'novel' || priorArtResults.novelty_analysis?.conclusion === 'no_anticipation_identified') 
                               ? 'No anticipation identified' :
                               (priorArtResults.novelty_analysis?.conclusion === 'anticipated' || priorArtResults.novelty_analysis?.conclusion === 'potential_anticipation')
                               ? 'Potential anticipation' : 'Review needed'}
                            </span>
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td style={{ padding: '10px 0', fontWeight: '500' }}>Inventive Step (Art. 56 EPC)</td>
                          <td style={{ padding: '10px 0', textAlign: 'right' }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: '4px',
                              fontWeight: 'bold',
                              fontSize: '12px',
                              background: priorArtResults.risk_pathways?.risk_level === 'low' ? '#e8f5e9' :
                                         priorArtResults.risk_pathways?.risk_level === 'high' ? '#ffebee' : '#fff3e0',
                              color: priorArtResults.risk_pathways?.risk_level === 'low' ? '#2e7d32' :
                                    priorArtResults.risk_pathways?.risk_level === 'high' ? '#c62828' : '#f57c00'
                            }}>
                              {(priorArtResults.risk_pathways?.risk_level === 'low' || priorArtResults.risk_pathways?.risk_level === 'lower')
                               ? 'Lower combination risk' :
                               (priorArtResults.risk_pathways?.risk_level === 'high' || priorArtResults.risk_pathways?.risk_level === 'higher')
                               ? 'Higher combination risk' : 'Moderate risk'}
                            </span>
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td style={{ padding: '10px 0', fontWeight: '500' }}>Sufficiency (Art. 83 EPC)</td>
                          <td style={{ padding: '10px 0', textAlign: 'right' }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: '4px',
                              fontWeight: 'bold',
                              fontSize: '12px',
                              background: '#fff3e0',
                              color: '#f57c00'
                            }}>
                              MODERATE
                            </span>
                            <span style={{ fontSize: '11px', color: '#666', marginLeft: '8px' }}>(drafting dependent)</span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: '10px 0', fontWeight: '500' }}>Clarity (Art. 84 EPC)</td>
                          <td style={{ padding: '10px 0', textAlign: 'right' }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: '4px',
                              fontWeight: 'bold',
                              fontSize: '12px',
                              background: priorArtResults.claim_construction?.risks?.length > 3 ? '#ffebee' :
                                         priorArtResults.claim_construction?.risks?.length > 0 ? '#fff3e0' : '#e8f5e9',
                              color: priorArtResults.claim_construction?.risks?.length > 3 ? '#c62828' :
                                    priorArtResults.claim_construction?.risks?.length > 0 ? '#f57c00' : '#2e7d32'
                            }}>
                              {priorArtResults.claim_construction?.risks?.length > 3 ? 'Multiple issues identified' :
                               priorArtResults.claim_construction?.risks?.length > 0 ? 'Some issues identified' : 'No major issues identified'}
                            </span>
                            <span style={{ fontSize: '11px', color: '#666', marginLeft: '8px' }}>(drafting dependent)</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '2px solid #1a237e' }}>
                      <p style={{ fontSize: '13px', margin: 0, lineHeight: '1.6', color: '#1a237e' }}>
                        <strong>Preliminary Observations:</strong> {(priorArtResults.preliminary_opinion.overall_assessment === 'preliminary_patentable' || priorArtResults.preliminary_opinion.overall_assessment === 'no_anticipation_identified') 
                          ? 'No anticipating reference was identified in the searched dataset (USPTO 2021-2024). Comprehensive assessment requires broader searching including pre-2021 patents, EP/WO/CN/JP/KR databases, and non-patent literature.'
                          : (priorArtResults.preliminary_opinion.overall_assessment === 'patentable_with_risks' || priorArtResults.preliminary_opinion.overall_assessment === 'potential_concerns_identified')
                            ? 'Potential concerns were identified in the searched dataset. Further review by a qualified patent attorney is recommended before filing decisions.'
                            : 'Significant concerns were identified in the searched dataset. Comprehensive prior art searching and attorney review are recommended before proceeding.'}
                      </p>
                    </div>
                    
                    {/* Attorney Action Checklist - Phase 5C */}
                    <div style={{ marginTop: '20px', padding: '16px', background: '#fff8e1', borderRadius: '8px', border: '2px solid #ffb300' }}>
                      <h5 style={{ fontSize: '13px', fontWeight: 'bold', color: '#e65100', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '16px' }}>⚠️</span> ATTORNEY ACTION CHECKLIST
                      </h5>
                      <p style={{ fontSize: '11px', color: '#666', marginBottom: '12px', fontStyle: 'italic' }}>
                        Before relying on this report for filing or business decisions:
                      </p>
                      <div style={{ display: 'grid', gap: '8px' }}>
                        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12px', color: '#333', cursor: 'pointer' }}>
                          <input type="checkbox" style={{ marginTop: '2px' }} />
                          <span><strong>Verify closest prior art selection</strong> — Confirm D1 is indeed the most relevant reference</span>
                        </label>
                        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12px', color: '#333', cursor: 'pointer' }}>
                          <input type="checkbox" style={{ marginTop: '2px' }} />
                          <span><strong>Conduct supplemental EP/WO search</strong> — This report covers USPTO only</span>
                        </label>
                        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12px', color: '#333', cursor: 'pointer' }}>
                          <input type="checkbox" style={{ marginTop: '2px' }} />
                          <span><strong>Review pre-2021 USPTO patents</strong> — Dataset limited to 2021-2024</span>
                        </label>
                        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12px', color: '#333', cursor: 'pointer' }}>
                          <input type="checkbox" style={{ marginTop: '2px' }} />
                          <span><strong>Assess non-patent literature</strong> — Academic papers, standards, technical publications</span>
                        </label>
                        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12px', color: '#333', cursor: 'pointer' }}>
                          <input type="checkbox" style={{ marginTop: '2px' }} />
                          <span><strong>Validate claim construction analysis</strong> — Review key terms and scope interpretation</span>
                        </label>
                        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12px', color: '#333', cursor: 'pointer' }}>
                          <input type="checkbox" style={{ marginTop: '2px' }} />
                          <span><strong>Consider CN/JP/KR prior art</strong> — Particularly relevant for technology areas with Asian filings</span>
                        </label>
                      </div>
                    </div>
                  </div>
                )}

                {/* Conclusions Grid */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
                  <div style={{ background: 'rgba(255,255,255,0.1)', padding: '16px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)' }}>
                    <h4 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#90caf9' }}>
                      {priorArtForm.jurisdiction === 'US' ? '§102 Novelty' : 'Art. 54 Novelty'} - Preliminary Assessment (Dataset Only)
                    </h4>
                    <p style={{ fontSize: '13px', margin: 0, lineHeight: '1.5' }}>{priorArtResults.preliminary_opinion.novelty_conclusion}</p>
                  </div>
                  <div style={{ background: 'rgba(255,255,255,0.1)', padding: '16px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)' }}>
                    <h4 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#90caf9' }}>
                      {priorArtForm.jurisdiction === 'US' ? '§103 Obviousness' : 'Art. 56 Inventive Step'} - Preliminary Assessment (Dataset Only)
                    </h4>
                    <p style={{ fontSize: '13px', margin: 0, lineHeight: '1.5' }}>{priorArtResults.preliminary_opinion.obviousness_conclusion}</p>
                  </div>
                </div>

                {/* Strengths and Risks */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
                  {priorArtResults.preliminary_opinion.key_strengths?.length > 0 && (
                    <div style={{ background: 'rgba(46, 125, 50, 0.2)', padding: '16px', borderRadius: '6px', border: '1px solid #4caf50' }}>
                      <h4 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '10px', color: '#a5d6a7' }}>Key Strengths</h4>
                      <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '12px', lineHeight: '1.6' }}>
                        {priorArtResults.preliminary_opinion.key_strengths.map((s, i) => (
                          <li key={i} style={{ marginBottom: '6px' }}>{s}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {priorArtResults.preliminary_opinion.key_risks?.length > 0 && (
                    <div style={{ background: 'rgba(198, 40, 40, 0.2)', padding: '16px', borderRadius: '6px', border: '1px solid #ef5350' }}>
                      <h4 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '10px', color: '#ef9a9a' }}>Key Risks</h4>
                      <ul style={{ margin: 0, paddingLeft: '18px', fontSize: '12px', lineHeight: '1.6' }}>
                        {priorArtResults.preliminary_opinion.key_risks.map((r, i) => (
                          <li key={i} style={{ marginBottom: '6px' }}>{r}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                {/* Recommendations */}
                {priorArtResults.preliminary_opinion.recommendations?.length > 0 && (
                  <div style={{ background: 'rgba(255,255,255,0.1)', padding: '16px', borderRadius: '6px', marginBottom: '16px', border: '1px solid rgba(255,255,255,0.3)' }}>
                    <h4 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '10px', color: '#ffcc80' }}>Recommendations</h4>
                    <ol style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.6' }}>
                      {priorArtResults.preliminary_opinion.recommendations.map((r, i) => (
                        <li key={i} style={{ marginBottom: '6px' }}>{r}</li>
                      ))}
                    </ol>
                  </div>
                )}

                {/* Next Steps */}
                {priorArtResults.preliminary_opinion.next_steps?.length > 0 && (
                  <div style={{ background: 'rgba(255,255,255,0.1)', padding: '16px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)' }}>
                    <h4 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '10px', color: '#81d4fa' }}>Recommended Next Steps</h4>
                    <ol style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.6' }}>
                      {priorArtResults.preliminary_opinion.next_steps.map((s, i) => (
                        <li key={i} style={{ marginBottom: '6px' }}>{s}</li>
                      ))}
                    </ol>
                  </div>
                )}

                <p style={{ fontSize: '10px', marginTop: '16px', marginBottom: 0, opacity: 0.7, fontStyle: 'italic' }}>
                  {priorArtForm.jurisdiction === 'US' 
                    ? 'This preliminary opinion is based solely on the USPTO dataset (2021-2024) searched and does not constitute legal advice. A qualified patent attorney must review and confirm all findings.'
                    : 'This preliminary assessment is based on a limited search of USPTO records (2021-2024) and does not constitute a formal patentability opinion. This report should not be relied upon for filing decisions. Instruction of a qualified patent attorney is essential before any filing or prosecution strategy is determined.'}
                </p>
              </div>
            )}

            {/* ACADEMIC PAPERS SECTION */}
            {priorArtResults.papers && priorArtResults.papers.length > 0 && (
              <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', marginBottom: '20px' }}>
                <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#1e40af', marginBottom: '12px' }}>Academic Papers ({priorArtResults.papers_count || priorArtResults.papers.length})</h3>
                <p style={{ color: '#64748b', marginBottom: '16px', fontSize: '13px' }}>Non-patent literature from OpenAlex, Semantic Scholar, and Crossref. Papers published before the priority date may constitute prior art under 35 USC 102.</p>
                {priorArtResults.papers.map((paper, idx) => {
                  const statusColors = {
                    'BEFORE_FILING': { bg: '#dcfce7', text: '#166534', label: 'Before Filing (102 Prior Art)' },
                    'AFTER_FILING': { bg: '#fee2e2', text: '#991b1b', label: 'After Filing' },
                    'DATE_UNCERTAIN': { bg: '#fef3c7', text: '#92400e', label: 'Date Uncertain' }
                  };
                  const status = statusColors[paper.publication_status] || statusColors['DATE_UNCERTAIN'];
                  return (
                    <div key={idx} style={{ border: '1px solid #e2e8f0', borderRadius: '6px', padding: '12px', marginBottom: '10px', background: '#fafafa' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                        <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b', margin: 0, flex: 1, paddingRight: '10px' }}>{paper.title}</h4>
                        <span style={{ backgroundColor: status.bg, color: status.text, padding: '2px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '600', whiteSpace: 'nowrap' }}>{status.label}</span>
                      </div>
                      <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '6px' }}>
                        {paper.venue && <span>{paper.venue} &bull; </span>}
                        {paper.publication_year && <span>{paper.publication_year} &bull; </span>}
                        <span>{paper.cited_by_count || 0} citations</span>
                      </div>
                      {paper.authors && paper.authors.length > 0 && (
                        <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '6px' }}>
                          {paper.authors.slice(0, 3).map(a => a.name).join(', ')}{paper.authors.length > 3 && ' et al.'}
                        </div>
                      )}
                      <div style={{ display: 'flex', gap: '10px', marginTop: '6px' }}>
                        {paper.doi && <a href={'https://doi.org/' + paper.doi} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#0369a1', textDecoration: 'none' }}>View Paper ↗</a>}
                        {paper.pdf_url && <a href={paper.pdf_url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#0369a1', textDecoration: 'none' }}>PDF ↗</a>}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* SEARCH METHODOLOGY - Moved for attorney report structure */}
            <div style={{ background: '#fff3e0', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '1px solid #ffcc80' }}>
              <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#e65100', marginBottom: '12px' }}>Search Parameters</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', fontSize: '14px' }}>
                <div>
                  <span style={{ fontWeight: '600', color: '#333' }}>Invention: </span>
                  <span style={{ color: '#555' }}>{priorArtForm.invention_title}</span>
                </div>
                <div>
                  <span style={{ fontWeight: '600', color: '#333' }}>Priority Date: </span>
                  <span style={{ color: '#555' }}>{priorArtForm.priority_date}</span>
                </div>
                <div>
                  <span style={{ fontWeight: '600', color: '#333' }}>Search Run: </span>
                  <span style={{ color: '#555' }}>{new Date().toLocaleString()}</span>
                </div>
              </div>
              <div style={{ marginTop: '12px', fontSize: '14px' }}>
                <span style={{ fontWeight: '600', color: '#333' }}>Description: </span>
                <span style={{ color: '#555', whiteSpace: 'pre-wrap' }}>{priorArtForm.invention_description}</span>
              </div>
              {priorArtForm.key_features?.filter(f => f.trim()).length > 0 && (
                <div style={{ marginTop: '12px', fontSize: '14px' }}>
                  <span style={{ fontWeight: '600', color: '#333' }}>Key Features:</span>
                  <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
                    {priorArtForm.key_features.filter(f => f.trim()).map((feature, idx) => (
                      <li key={idx} style={{ color: '#555', marginBottom: '4px' }}>{feature}</li>
                    ))}
                  </ul>
                </div>
              )}
              {priorArtForm.distilled_claim?.trim() && (
                <div style={{ marginTop: '12px', fontSize: '14px', background: '#fce4ec', padding: '12px', borderRadius: '4px', border: '1px solid #f48fb1' }}>
                  <span style={{ fontWeight: '600', color: '#c2185b', display: 'block', marginBottom: '8px' }}>Distilled Independent Claim:</span>
                  <span style={{ color: '#555', whiteSpace: 'pre-wrap', fontStyle: 'italic' }}>{priorArtForm.distilled_claim}</span>
                </div>
              )}
            </div>

            {priorArtResults.search_strategy && (
              <div style={{ background: '#e8eaf6', padding: '16px', borderRadius: '8px', marginBottom: '24px', border: '1px solid #9fa8da' }}>
                <h3 style={{ fontSize: '14px', fontWeight: 'bold', color: '#3949ab', marginBottom: '12px' }}>AI Search Strategy</h3>
                <div style={{ fontSize: '13px', marginBottom: '12px' }}>
                  <span style={{ fontWeight: '600', color: '#333' }}>Keywords: </span>
                  <span style={{ color: '#555' }}>{priorArtResults.search_strategy.keywords?.join(', ') || 'None'}</span>
                </div>
                <div style={{ fontSize: '13px' }}>
                  <span style={{ fontWeight: '600', color: '#333' }}>CPC Classifications:</span>
                  {priorArtResults.search_strategy.cpc_descriptions?.length > 0 ? (
                    <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
                      {priorArtResults.search_strategy.cpc_descriptions.map((cpc, idx) => (
                        <li key={idx} style={{ color: '#555', marginBottom: '4px' }}>
                          <strong style={{ color: '#3949ab' }}>{cpc.code}</strong> - {cpc.title}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span style={{ color: '#555', marginLeft: '8px' }}>{priorArtResults.search_strategy.cpc_codes?.join(', ') || 'None detected'}</span>
                  )}
                </div>
                <div style={{ fontSize: '13px', marginTop: '12px' }}>
                  <span style={{ fontWeight: '600', color: '#333' }}>Sources Searched: </span>
                  <span style={{ color: '#555' }}>
                    {priorArtResults.granted_count?.toLocaleString() || 0} granted patents + {priorArtResults.applications_count?.toLocaleString() || 0} pending applications
                  </span>
                </div>
                <div style={{ fontSize: '13px', marginTop: '8px' }}>
                  <span style={{ fontWeight: '600', color: '#333' }}>Date Filter: </span>
                  <span style={{ color: '#555' }}>Published before {priorArtResults.priority_date}</span>
                </div>
                {priorArtForm.jurisdiction === 'US' && (
                  <div style={{ fontSize: '13px', marginTop: '8px' }}>
                    <span style={{ fontWeight: '600', color: '#333' }}>AI Scoring: </span>
                    <span style={{ color: '#555' }}>Top {priorArtResults.results_shown} results scored for similarity to your invention</span>
                  </div>
                )}
              </div>
            )}

            {priorArtForm.jurisdiction === 'US' && (
            <div style={{ background: '#f5f5f5', padding: '16px', borderRadius: '8px', marginBottom: '24px', border: '1px solid #ddd' }}>
              <h3 style={{ fontSize: '14px', fontWeight: 'bold', color: '#333', marginBottom: '12px' }}>Similarity Score Guide</h3>
              <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', fontSize: '13px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ width: '16px', height: '16px', background: '#d32f2f', borderRadius: '3px' }}></div>
                  <span><strong>80%+</strong> - Highly relevant. Potential blocking prior art. Review claims carefully.</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ width: '16px', height: '16px', background: '#f57c00', borderRadius: '3px' }}></div>
                  <span><strong>60-79%</strong> - Moderately relevant. Similar technology area. May affect claim scope.</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ width: '16px', height: '16px', background: '#fbc02d', borderRadius: '3px' }}></div>
                  <span><strong>40-59%</strong> - Somewhat relevant. Background art. Consider for context.</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ width: '16px', height: '16px', background: '#757575', borderRadius: '3px' }}></div>
                  <span><strong>&lt;40%</strong> - Low relevance. Different problem or mechanism.</span>
                </div>
              </div>
              <p style={{ fontSize: '11px', color: '#888', marginTop: '12px', fontStyle: 'italic' }}>
                Note: Similarity percentages reflect AI-based semantic similarity scoring and are provided for ranking purposes only, not legal significance.
              </p>
            </div>
            )}

            {/* CLAIM DRAFTING RECOMMENDATIONS - Attorney Guidance */}
            {priorArtResults.claim_construction && (
              <div style={{ background: 'linear-gradient(135deg, #4a148c 0%, #7b1fa2 100%)', padding: '24px', borderRadius: '8px', marginBottom: '24px', color: 'white' }}>
                <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontSize: '24px' }}>&#9998;</span>
                  Claim Drafting Recommendations
                </h2>
                
                <p style={{ fontSize: '13px', marginBottom: '20px', opacity: 0.9, lineHeight: '1.6' }}>
                  Based on the identified prior art and claim construction analysis, the following drafting guidance is provided to strengthen patent claims and address potential examination issues.
                </p>

                {/* Narrowing Recommendations - US only (UK/EPO uses Problem-Solution) */}
                {priorArtForm.jurisdiction === 'US' && (
                <>
                <div style={{ background: 'rgba(255,255,255,0.1)', padding: '16px', borderRadius: '6px', marginBottom: '16px', border: '1px solid rgba(255,255,255,0.3)' }}>
                  <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px', color: '#ce93d8' }}>Recommended Claim Narrowing</h4>
                  <p style={{ fontSize: '12px', marginBottom: '12px', opacity: 0.9 }}>
                    To distinguish from identified prior art and reduce rejection risk, consider:
                  </p>
                  <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                    {priorArtResults.claim_construction.risks?.slice(0, 3).map((risk, i) => (
                      <li key={i} style={{ marginBottom: '8px' }}>
                        <strong style={{ color: '#ffcc80' }}>Re: "{risk.term || risk.element || 'Claim element'}"</strong> — 
                        Add structural limitations or quantitative thresholds to provide clearer metes and bounds. 
                        {risk.recommendation && <span> Specifically: {risk.recommendation}</span>}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Dependent Claim Suggestions */}
                <div style={{ background: 'rgba(255,255,255,0.1)', padding: '16px', borderRadius: '6px', marginBottom: '16px', border: '1px solid rgba(255,255,255,0.3)' }}>
                  <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px', color: '#ce93d8' }}>Suggested Dependent Claims (Fallback Positions)</h4>
                  <p style={{ fontSize: '12px', marginBottom: '12px', opacity: 0.9 }}>
                    Include dependent claims capturing specific implementations to preserve narrower scope if independent claims face rejection:
                  </p>
                  <ol style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                    <li style={{ marginBottom: '6px' }}>Dependent claim specifying particular materials, compositions, or structural arrangements</li>
                    <li style={{ marginBottom: '6px' }}>Dependent claim reciting specific numerical ranges or performance thresholds</li>
                    <li style={{ marginBottom: '6px' }}>Dependent claim limiting to preferred embodiment described in specification</li>
                    <li style={{ marginBottom: '6px' }}>Method claim if independent is apparatus (or vice versa) for claim diversity</li>
                  </ol>
                </div>
                </>
                )}

                {/* Claim Compliance - Jurisdiction Aware */}
                <div style={{ background: 'rgba(255,255,255,0.1)', padding: '16px', borderRadius: '6px', marginBottom: '16px', border: '1px solid rgba(255,255,255,0.3)' }}>
                  <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px', color: '#ce93d8' }}>
                    {priorArtForm.jurisdiction === 'US' ? '§112 Compliance Recommendations' : 'Art. 83/84 EPC Compliance Recommendations'}
                  </h4>
                  {priorArtForm.jurisdiction === 'US' ? (
                    <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                      <li style={{ marginBottom: '6px' }}><strong>Written Description (§112(a)):</strong> Ensure specification fully supports all claimed features with sufficient detail</li>
                      <li style={{ marginBottom: '6px' }}><strong>Enablement (§112(a)):</strong> Verify one skilled in art can make/use invention without undue experimentation</li>
                      <li style={{ marginBottom: '6px' }}><strong>Definiteness (§112(b)):</strong> Replace functional language with structural definitions where possible</li>
                      <li style={{ marginBottom: '6px' }}><strong>Claim Format (§112(d)-(f)):</strong> Ensure proper antecedent basis and means-plus-function compliance</li>
                    </ul>
                  ) : (
                    <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                      <li style={{ marginBottom: '6px' }}><strong>Sufficiency (Art. 83):</strong> Ensure specification enables skilled person to perform the invention across full claim scope (see T 409/91)</li>
                      <li style={{ marginBottom: '6px' }}><strong>Clarity (Art. 84):</strong> Claims must be clear and concise; avoid ambiguous or relative terms (see T 68/85)</li>
                      <li style={{ marginBottom: '6px' }}><strong>Support (Art. 84):</strong> Every claimed feature must be directly supported by the description (see T 759/91)</li>
                      <li style={{ marginBottom: '6px' }}><strong>Added Matter (Art. 123(2)):</strong> Any amendments must be directly and unambiguously derivable from original filing</li>
                    </ul>
                  )}
                </div>

                {/* Examination Strategy */}
                <div style={{ background: 'rgba(255,255,255,0.1)', padding: '16px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)' }}>
                  <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px', color: '#ce93d8' }}>Prosecution Strategy Notes</h4>
                  <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                    <li style={{ marginBottom: '6px' }}><strong>{priorArtForm.jurisdiction === 'US' ? '§102' : 'Art. 54'} Response:</strong> If novelty rejection issued, emphasize elements not disclosed in single reference</li>
                    <li style={{ marginBottom: '6px' }}><strong>{priorArtForm.jurisdiction === 'US' ? '§103' : 'Art. 56'} Response:</strong> {priorArtForm.jurisdiction === 'US' ? 'Challenge motivation to combine; argue against hindsight reconstruction; emphasize unexpected results if applicable' : 'Challenge problem-solution analysis; argue skilled person would not have been motivated to combine; emphasize technical effect'}</li>
                    <li style={{ marginBottom: '6px' }}><strong>Secondary Considerations:</strong> Document commercial success, long-felt need, failure of others, industry praise</li>
                    <li style={{ marginBottom: '6px' }}><strong>Interview Practice:</strong> Consider examiner interview after first Office Action to clarify claim scope</li>
                  </ul>
                </div>

                <p style={{ fontSize: '10px', marginTop: '16px', marginBottom: 0, opacity: 0.7, fontStyle: 'italic' }}>
                  These recommendations are AI-generated suggestions based on identified prior art patterns. A qualified patent attorney should review and tailor claim language to specific prosecution goals.
                </p>
              </div>
            )}

            {/* APPENDICES - Attorney Reference Materials */}
            <div style={{ marginTop: '32px', borderTop: '3px solid #1565c0', paddingTop: '24px' }}>
              <h2 style={{ fontSize: '22px', fontWeight: 'bold', color: '#0d47a1', marginBottom: '24px' }}>
                Appendices
              </h2>

              {/* Appendix A: Full Independent Claims */}
              <details style={{ background: '#f5f5f5', borderRadius: '8px', marginBottom: '16px', border: '1px solid #ddd' }}>
                <summary style={{ padding: '16px', cursor: 'pointer', fontWeight: 'bold', color: '#333', fontSize: '16px' }}>
                  Appendix A: Full Independent Claims of Top References
                  <span style={{ fontWeight: 'normal', marginLeft: '8px', fontSize: '12px', color: '#666' }}>- Click to expand</span>
                </summary>
                <div style={{ padding: '16px', paddingTop: '0' }}>
                  <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
                    Complete Claim 1 text for each top-scoring reference. Use for detailed claim comparison and charting.
                  </p>
                  {priorArtResults.results?.slice(0, 6).map((patent, idx) => (
                    <div key={patent.patent_number} style={{ background: 'white', padding: '16px', borderRadius: '6px', marginBottom: '12px', border: '1px solid #e0e0e0' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                        <div>
                          <a href={'https://patents.google.com/patent/US' + patent.patent_number + '/en#claims'} 
                             target="_blank" rel="noopener noreferrer" 
                             style={{ fontSize: '16px', fontWeight: 'bold', color: '#1565c0', textDecoration: 'none' }}>
                            US{patent.patent_number}
                          </a>
                          <span style={{ marginLeft: '12px', fontSize: '12px', color: '#666' }}>
                            {priorArtForm.jurisdiction === 'US' && `(${patent.similarity_score}% similarity)`}
                          </span>
                        </div>
                        <span style={{ fontSize: '11px', color: '#888' }}>Reference {idx + 1}</span>
                      </div>
                      <p style={{ fontSize: '13px', fontWeight: '500', color: '#333', marginBottom: '8px' }}>
                        {patent.title}
                      </p>
                      <div style={{ background: '#fafafa', padding: '12px', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                        <p style={{ fontSize: '11px', fontWeight: '600', color: '#666', marginBottom: '8px' }}>
                          Independent Claim 1:
                        </p>
                        <p style={{ fontSize: '12px', color: '#333', lineHeight: '1.6', whiteSpace: 'pre-wrap', fontFamily: 'Georgia, serif', margin: 0 }}>
                          {(() => {
                            if (!patent.claims_text) return 'Claims text not available for this reference.';
                            const claim1Regex = /Claim\s*00001:([\s\S]*?)(?=Claim\s*\d{5}:|$)/i;
                            const match = patent.claims_text.match(claim1Regex);
                            if (match && match[1]) {
                              return match[1].replace(/^\s*1\.\s*/, '').trim() || 'Claim 1 not found in structured format.';
                            }
                            const fallbackRegex = /^\s*1\.\s*([\s\S]*?)(?=\n\s*2\.|$)/;
                            const fallbackMatch = patent.claims_text.match(fallbackRegex);
                            if (fallbackMatch && fallbackMatch[1]) {
                              return fallbackMatch[1].trim();
                            }
                            return patent.claims_text.substring(0, 1500) + (patent.claims_text.length > 1500 ? '...' : '');
                          })()}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </details>

              {/* Appendix B: CPC Classification Breakdown */}
              {priorArtResults.search_strategy?.cpc_descriptions?.length > 0 && (
                <details style={{ background: '#f5f5f5', borderRadius: '8px', marginBottom: '16px', border: '1px solid #ddd' }}>
                  <summary style={{ padding: '16px', cursor: 'pointer', fontWeight: 'bold', color: '#333', fontSize: '16px' }}>
                    Appendix B: CPC Classification Breakdown
                    <span style={{ fontWeight: 'normal', marginLeft: '8px', fontSize: '12px', color: '#666' }}>- Click to expand</span>
                  </summary>
                  <div style={{ padding: '16px', paddingTop: '0' }}>
                    <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
                      Cooperative Patent Classification codes used in this search. These define the technical scope of the prior art analysis.
                    </p>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', background: 'white' }}>
                      <thead>
                        <tr style={{ background: '#e3f2fd' }}>
                          <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #1565c0', width: '20%' }}>CPC Code</th>
                          <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #1565c0' }}>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {priorArtResults.search_strategy.cpc_descriptions.map((cpc, idx) => (
                          <tr key={idx} style={{ background: idx % 2 === 0 ? '#fafafa' : 'white' }}>
                            <td style={{ padding: '12px', borderBottom: '1px solid #e0e0e0', fontWeight: '600', color: '#1565c0', fontFamily: 'monospace' }}>
                              {cpc.code}
                            </td>
                            <td style={{ padding: '12px', borderBottom: '1px solid #e0e0e0', color: '#333' }}>
                              {cpc.title || cpc.description || 'Description not available'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <p style={{ fontSize: '11px', color: '#666', marginTop: '12px', fontStyle: 'italic' }}>
                      CPC codes are assigned by patent examiners and indicate the technical field of each patent. Multiple codes may apply to a single invention.
                    </p>
                  </div>
                </details>
              )}

              {/* Appendix C: Search Metadata */}
              <details style={{ background: '#f5f5f5', borderRadius: '8px', marginBottom: '16px', border: '1px solid #ddd' }}>
                <summary style={{ padding: '16px', cursor: 'pointer', fontWeight: 'bold', color: '#333', fontSize: '16px' }}>
                  Appendix C: Search Metadata & Reproducibility
                  <span style={{ fontWeight: 'normal', marginLeft: '8px', fontSize: '12px', color: '#666' }}>- Click to expand</span>
                </summary>
                <div style={{ padding: '16px', paddingTop: '0' }}>
                  <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
                    Technical details enabling search reproducibility and audit trail documentation.
                  </p>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', background: 'white' }}>
                    <tbody>
                      <tr style={{ background: '#fafafa' }}>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600', width: '30%' }}>Search Date</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>{new Date().toISOString().split('T')[0]}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600' }}>Priority Date Filter</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>Before {priorArtForm.priority_date}</td>
                      </tr>
                      <tr style={{ background: '#fafafa' }}>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600' }}>Database</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>USPTO (2021-2024), ~1.45M documents</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600' }}>Total Results Found</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>{priorArtResults.total_found?.toLocaleString() || 'N/A'}</td>
                      </tr>
                      <tr style={{ background: '#fafafa' }}>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600' }}>Granted Patents</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>{priorArtResults.granted_count?.toLocaleString() || 'N/A'}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600' }}>Pending Applications</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>{priorArtResults.applications_count?.toLocaleString() || 'N/A'}</td>
                      </tr>
                      <tr style={{ background: '#fafafa' }}>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600' }}>AI-Scored References</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>{priorArtResults.results_shown || 'N/A'}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600' }}>Keywords Used</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>{priorArtResults.search_strategy?.keywords?.join(', ') || 'N/A'}</td>
                      </tr>
                      <tr style={{ background: '#fafafa' }}>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0', fontWeight: '600' }}>CPC Codes Searched</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}>{priorArtResults.search_strategy?.cpc_codes?.join(', ') || 'N/A'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </details>
            </div>
	    </>
	    )}
          </div>
        )}
      </main>
    </div>
  );
}

export default PriorArtPage;
